"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3203],{

/***/ 95315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ usePrefetchedSignupAssets; },
/* harmony export */   "v": function() { return /* binding */ PrefetchSignupAssetsProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var constants_platform_links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16119);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27639);
/* harmony import */ var constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83139);
/* harmony import */ var services_environment_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56274);
/* harmony import */ var services_environment_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(services_environment_service__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mondaydotcomorg_trident_skeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96842);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







var SIGNUP_CLOUDINARY_ASSETS_DIRECTORY = "https://dapulse-res.cloudinary.com/image/upload/monday_platform/signup";
var SIGNUP_BACKGROUND_IMAGE_SRC = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-background.png");
var SIGNUP_LOADER_IMAGE_SRC = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/loader_transparent_new.gif");
var SET_UP_YOUR_ACCOUNT_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/set-up-your-account-right-side-asset.png");
var COMPANY_AND_TEAM_SIZE_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/company-and-team-size-right-side-asset.png");
var HOW_WOULD_YOU_LIKE_TO_USE_MONDAY_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/how-would-you-like-to-use-monday-right-side-asset.png");
var WHAT_BRINGS_YOU_HERE_RIGHT_SIDE_ASSET = "".concat(SIGNUP_CLOUDINARY_ASSETS_DIRECTORY, "/signup-right-side-assets/what-brings-you-here-right-side-asset.png");
var STATIC_ASSETS_HREFS = [
    SIGNUP_BACKGROUND_IMAGE_SRC,
    SIGNUP_LOADER_IMAGE_SRC,
    SET_UP_YOUR_ACCOUNT_RIGHT_SIDE_ASSET,
    COMPANY_AND_TEAM_SIZE_RIGHT_SIDE_ASSET,
    HOW_WOULD_YOU_LIKE_TO_USE_MONDAY_RIGHT_SIDE_ASSET,
    WHAT_BRINGS_YOU_HERE_RIGHT_SIDE_ASSET
];
var PREFETCHED_DOMAINS = [
    (0,constants_platform_links__WEBPACK_IMPORTED_MODULE_5__/* .getPlatformLinkByEnvironment */ .k)(constants_links__WEBPACK_IMPORTED_MODULE_2__/* .MONDAY_AUTH_DOMAIN */ .NyZ)
];
var PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;
var PrefetchedSignupAssetsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("PrefetchedSignupAssets");
var HOST_NAME = "homepage";
var SIGNUP_MF_NAME = "mf-platform-signup";
var PrefetchSignupAssetsProvider = function(props) {
    var children = props.children, signupDynamicAssetsLinks = props.signupDynamicAssetsLinks;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), prefetchedSignupAssetsLinks = ref[0], setPrefetchedSignupAssetsLinks = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (services_environment_service__WEBPACK_IMPORTED_MODULE_4__.isDevelopment) return;
        try {
            var skeleton = new _mondaydotcomorg_trident_skeleton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z({
                api: {},
                isDev: services_environment_service__WEBPACK_IMPORTED_MODULE_4__.isDevelopment,
                mfUrl: constants_links__WEBPACK_IMPORTED_MODULE_2__/* .MICRO_FRONTENDS_DOMAIN */ .vM1,
                host: {
                    name: HOST_NAME,
                    environment: services_environment_service__WEBPACK_IMPORTED_MODULE_4__.env
                },
                isAssetsFlattened: true,
                shouldUseMfAssetsEndpoint: true,
                useMfAssetsFallback: true
            });
            skeleton.preFetchMF(SIGNUP_MF_NAME);
        } catch (e) {
        // just to keep it safe and quiet
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var setData = function() {
            var _ref = _async_to_generator(function() {
                var // dynamic assets
                _signupAssetsLinks, signupAssetsLinks;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    signupAssetsLinks = [];
                    // dns prefetches
                    PREFETCHED_DOMAINS.forEach(function(href) {
                        signupAssetsLinks.push({
                            type: constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREFETCH_TYPES.DNS_PREFETCH */ .DO.DNS_PREFETCH,
                            href: href
                        });
                    });
                    // pre-connects
                    PRECONNECT_DOMAINS.forEach(function(href) {
                        signupAssetsLinks.push({
                            type: constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREFETCH_TYPES.PRECONNECT */ .DO.PRECONNECT,
                            href: href
                        });
                    });
                    // static assets
                    STATIC_ASSETS_HREFS.forEach(function(href) {
                        signupAssetsLinks.push({
                            type: constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREFETCH_TYPES.PREFETCH */ .DO.PREFETCH,
                            href: href
                        });
                    });
                    (_signupAssetsLinks = signupAssetsLinks).push.apply(_signupAssetsLinks, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(signupDynamicAssetsLinks));
                    setPrefetchedSignupAssetsLinks(signupAssetsLinks);
                    return [
                        2
                    ];
                });
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrefetchedSignupAssetsContext.Provider, {
        value: prefetchedSignupAssetsLinks,
        children: children
    });
};
var usePrefetchedSignupAssets = function() {
    var prefetchedSignupAssetsLinks = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PrefetchedSignupAssetsContext) || [];
    return prefetchedSignupAssetsLinks;
};


/***/ }),

/***/ 17730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ bypass_block_menu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/accessibility/bypass-blocks-menu/bypass-block-menu.scss.js

var StyledBypassBlocksMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("nav", {
    target: "e1o6bwvc0"
})(".menu-item{position:fixed;top:0;left:0;opacity:0;pointer-events:none;&:focus{opacity:1;pointer-events:auto;}}");

;// CONCATENATED MODULE: ./components/accessibility/bypass-blocks-menu/bypass-block-menu.js





var BypassBlocksMenuComponent = function(props) {
    var ref = (0,react.useState)(false), hasFooter = ref[0], setHasFooter = ref[1];
    (0,react.useEffect)(function() {
        var footer = document.querySelector(element_ids/* FOOTER_ID */.D);
        setHasFooter(!!footer);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBypassBlocksMenuComponent, {
        className: "bypass-block-menu-component",
        "aria-label": "Accessibility Menu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#".concat(element_ids/* MAIN_ID */.k),
                className: "menu-item",
                children: props.translate("accessibility.blocksMenu.skipToMain")
            }),
            hasFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#".concat(element_ids/* FOOTER_ID */.D),
                className: "menu-item",
                children: props.translate("accessibility.blocksMenu.skipToFooter")
            })
        ]
    });
};
/* harmony default export */ var bypass_block_menu = ((0,generic_config_context/* withGenericConfig */.P)(BypassBlocksMenuComponent));


/***/ }),

/***/ 54172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _constants_marketing_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70890);


var GoogleTagManagerComponent = function(param) {
    var _loadBodyScript = param.loadBodyScript, loadBodyScript = _loadBodyScript === void 0 ? false : _loadBodyScript, _gtmId = param.gtmId, gtmId = _gtmId === void 0 ? _constants_marketing_keys__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_TAG_MANAGER_HOMEPAGE_CONTAINER */ .g : _gtmId;
    var getHeaderScript = function() {
        return "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(gtmId, "');");
    };
    var getBodyNoScript = function() {
        return '<iframe src="https://www.googletagmanager.com/ns.html?id='.concat(gtmId, '"\n    height="0" width="0" style="display:none;visibility:hidden"></iframe>');
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !loadBodyScript && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: getHeaderScript()
                }
            }),
            loadBodyScript && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: getBodyNoScript()
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleTagManagerComponent);


/***/ }),

/***/ 36403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BigBrainScript; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./components/core/head/products-service.js



var _obj;
var CLUSTER_TO_PRODUCT_ID = (_obj = {}, (0,_define_property/* default */.Z)(_obj, clusters.CONSTRUCTION, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.HR, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.OPERATIONS, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.IT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PMO, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PRODUCT_MANAGEMENT, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.DESIGN_AND_CREATIVE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.TASKS_AND_TODOS, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.FINANCE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.CREATIVE, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.CRM, products/* CRM_PRODUCT_ID */.$), (0,_define_property/* default */.Z)(_obj, clusters.SOFTWARE, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.WORK_MANAGEMENT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.MARKETING, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.FUNDRAISING, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.NON_PROFIT, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,_define_property/* default */.Z)(_obj, clusters.PROJECTS_FLOW, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), _obj);
var getProductTypeFromCluster = function(clusterId) {
    return CLUSTER_TO_PRODUCT_ID[clusterId];
};

;// CONCATENATED MODULE: ./components/core/head/bigbrain-script.js







var BIGBRAIN_SCRIPT_URL = "https://informer-cdn2.monday.com/monday-informer-1.0.min.js";
var BIGBRAIN_URL = "https://data.bigbrain.me" || 0;
var BigBrainScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BigBrainScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BigBrainScript);
    function BigBrainScript() {
        (0,_class_call_check/* default */.Z)(this, BigBrainScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(BigBrainScript, [
        {
            key: "renderBigBrainTracker",
            value: function renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest) {
                var clusterIdToTrack = clusterId ? "".concat(clusterId).concat(subClusterId ? ",".concat(subClusterId) : "") : "";
                var exactPageAbTestTrack = exactPageAbTest ? "BigBrain('track', \"".concat(exactPageAbTest.name, '", { ab_test: "').concat(exactPageAbTest.variant, '" });') : "";
                return "\n      var brand_name = 'monday.com';\n      var template = '".concat(template, '\';\n\n      function add_general_event_props(args) {\n        event_props = {};\n        if(args.length == 3) {\n          event_props = args[2];\n        }\n\n        event_props[\'timestamp\'] = parseInt(new Date().getTime()/1000);\n        event_props["source"] = event_props["source"] || "monday_homepage";\n        event_props["group"] = "website";\n\n        if (args.length == 2) {\n          args.push(event_props);\n        }\n        else {\n          args[2] = event_props;\n        }\n        return args;\n      }\n\n      if (').concat(isProduction, ") {\n        window.BigBrainQ = window.BigBrainQ || [];\n        window.BigBrain = window.BigBrain || function(){\n          args = Array.prototype.slice.call(arguments)\n          if(args[0] == 'track'){\n            args = add_general_event_props(args)\n          }\n          window.BigBrainQ.push(args);\n        };\n\n        (function(d,u,callback){\n          if (window.BigBrainInit) return;\n          window.BigBrainInit = true;\n          var s = d.createElement('script');\n          s.type = 'text/javascript'\n          s.src = u;\n          s.async = true;\n          s.onreadystatechange = s.onload = function(){\n            var st = s.readyState;\n            if (!callback.done && (!st || /loaded|complete/.test(st))) {\n              callback.done = true;\n              callback();\n            }\n          };\n          (d.body || d.head).appendChild(s);\n        })(document, '").concat(BIGBRAIN_SCRIPT_URL, "', function() { \n            window.BigBrain = new BigBrainTracker({bigbrain_url: '").concat(BIGBRAIN_URL, "', send_immediately: true, create_visitor: ").concat(createVisitor, ", is_tracker_cross_domain: ").concat(!!crossDomain, ", emit_visitor_id: ").concat(!!emitVisitorId, ', emit_target_origin: "').concat(emitTargetOrigin, "\"});\n        });\n\n      } else {\n        window.BigBrain = function() {\n          args = Array.prototype.slice.call(arguments)\n          if(args[0] == 'track' || args[0] == 'set_utm_cluster_id'  ||  args[0] == 'set_utm_locale_id') {\n            args = add_general_event_props(args)\n            argsn = args.map(function(t) {\n              if (typeof(t) === 'object')\n                return JSON.stringify(t);\n              else\n                return t;\n            });\n            console.info(argsn);\n          }\n        }\n      }\n\n      if (").concat(!preventPageView, ") {\n        var type = document.getElementsByTagName('body')[0].dataset.pageType || '").concat(pageType, "';\n        if (type === undefined || (typeof (type) == 'string' && type.length == 0) || type == 'homepage'){\n          type = 'homepage';\n        } else {\n          type = '").concat(pageType, '\';\n        }\n        window.visitGuid = window.visitGuid || Math.ceil(Math.random() * 10000000);\n        var options = {\n          kind: location.pathname, \n          source: type, info2: template || "", \n          info3: location.href, \n          direct_object: window.visitGuid, \n          info1: "').concat(clusterIdToTrack, '", \n          data: {\n            segments: "').concat(segmentsList, '",\n            windowInnerWidth: window.innerWidth,\n            windowInnerHeight: window.innerHeight,\n            product: "').concat(pageProductId || getProductTypeFromCluster(clusterId), "\"\n          }\n        };\n        BigBrain('track', 'page_view', options);\n        ").concat(exactPageAbTestTrack, "\n      }\n  ");
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, template = _props.template, isProduction = _props.isProduction, pageType = _props.pageType, clusterId = _props.clusterId, subClusterId = _props.subClusterId, preventPageView = _props.preventPageView, createVisitor = _props.createVisitor, crossDomain = _props.crossDomain, emitVisitorId = _props.emitVisitorId, emitTargetOrigin = _props.emitTargetOrigin, segmentsList = _props.segmentsList, pageProductId = _props.pageProductId, exactPageAbTest = _props.exactPageAbTest;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    dangerouslySetInnerHTML: {
                        __html: this.renderBigBrainTracker(template, isProduction, pageType, clusterId, subClusterId, preventPageView, createVisitor, crossDomain, emitVisitorId, emitTargetOrigin, segmentsList, pageProductId, exactPageAbTest)
                    }
                });
            }
        }
    ]);
    return BigBrainScript;
}(react.PureComponent);

BigBrainScript.defaultProps = {
    pageType: "homepage",
    createVisitor: true
};


/***/ }),

/***/ 28069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);


var buildSeoFAQ = function(param) {
    var seoFAQ = param.seoFAQ, translate = param.translate;
    var res = null;
    try {
        var fixString = function(str) {
            return str.replace(/"/g, "'");
        };
        var renderFaqSeo = function() {
            return '\n{\n  "@context": "https://schema.org",\n  "@type": "FAQPage",\n  "mainEntity": ['.concat(seoFAQ.map(function(param) {
                var answer = param.answer, question = param.question;
                return '\n    {\n      "@type": "Question",\n      "name": "'.concat(fixString(translate(question)), '",\n      "acceptedAnswer": {\n        "@type": "Answer",\n        "text": "').concat(fixString(translate(answer)), '"\n      }\n    }');
            }), "]\n}\n      ");
        };
        if (seoFAQ) {
            res = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: renderFaqSeo()
                }
            });
        }
    } catch (error) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error);
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureMessage */ .uT("Failed to inject FAQ data to header");
    }
    return res;
};
/* harmony default export */ __webpack_exports__["Z"] = (buildSeoFAQ);


/***/ }),

/***/ 11094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var FontsComponent = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-200.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-300.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-regular.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-600.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-700.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FontsComponent);


/***/ }),

/***/ 98016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40927);
/* harmony import */ var services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27639);



var GoogleStructuredData = function() {
    var renderGoogleStructuredData = function() {
        return '\n      {\n        "@context": "http://schema.org",\n        "@type": "Organization",\n        "legalName": "monday.com Ltd",\n        "description": "monday.com Work OS is an open platform where anyone can create the tools they need to run every aspect of their work.",\n        "logo": "'.concat((0,services_community_cloudinary_service__WEBPACK_IMPORTED_MODULE_1__.generateCloudinaryImageUrl)(constants_links__WEBPACK_IMPORTED_MODULE_2__/* .MONDAY_SQUARE_LOGO_SRC */ .GD), '",\n        "name": "monday.com",\n        "sameAs": [\n          "https://twitter.com/mondaydotcom",\n          "https://www.facebook.com/mondaydotcom/",\n          "https://www.linkedin.com/company/monday.com/",\n          "https://www.youtube.com/channel/UCA9UvBiKHly15rN8u_Km3BQ"\n        ],\n        "url": "https://monday.com"\n      }\n    ');
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: renderGoogleStructuredData()
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GoogleStructuredData);


/***/ }),

/***/ 25433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ header_scripts_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./services/cookies/coupon-cookies-service.js


var saveCouponCookie = function() {
    var coupon = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    coupon.code && (0,cookies_service/* setCookie */.d8)(cookies.COUPON_CODE, coupon.code, {
        expires: parseInt(coupon.daysToExpire) || cookies.COUPON_DAYS_EXPIRE_DEFAULT
    });
};

// EXTERNAL MODULE: ./services/clusters-service.js
var clusters_service = __webpack_require__(90958);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./services/locales-service.js




var setLocaleIdAndTrackEventIfNeeded = function(localeId, reason, options) {
    (0,cookies_service/* setCookie */.d8)(cookies.LOCALE_COOKIE, localeId, {
        expires: cookies.COOKIE_EXPIRY_DAYS_FOR_LOCALIZATION
    });
    (0,bigbrain_service.setUtmLocaleId)(localeId);
    if (options.sendBigBrainEvent) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SET_LOCALE_ID_EVENT_NAME, {
            kind: localeId,
            info1: reason,
            info2: window.location.href
        });
    }
};
var setLocaleIdIfNeeded = function(configLocaleId) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (configLocaleId) {
        setLocaleIdAndTrackEventIfNeeded(configLocaleId, "set_locale_from_page_config", options);
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./services/community/constants-service.js
var constants_service = __webpack_require__(72137);
;// CONCATENATED MODULE: ./services/cookies/marketing-cookies-service.js





var windowLocationIEFix = function() {
    return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "");
};
var setMarketingCookies = function(marketingCookies) {
    Object.keys(marketingCookies).forEach(function(key) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(key, marketingCookies[key]);
    });
};
var saveMarketingCookies = function() {
    var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location;
    try {
        // Parse URI, get query string hash
        var queryString = (0,utils_url.getQueryStringAsHash)(url);
        // IE doesn't have location.origin
        if (!window.location.origin) {
            window.location.origin = windowLocationIEFix();
        }
        var _obj;
        // Extract martketing parameters from url
        var marketingCookies = (_obj = {}, (0,_define_property/* default */.Z)(_obj, cookies.M_CAMPAIGN, queryString.marketing_campaign || queryString.utm_campaign), (0,_define_property/* default */.Z)(_obj, cookies.M_CAMPAIGN_ID, queryString.marketing_campaign_id || queryString.utm_campaign_id), (0,_define_property/* default */.Z)(_obj, cookies.M_SOURCE, queryString.marketing_source || queryString.utm_source), (0,_define_property/* default */.Z)(_obj, cookies.M_BANNER, queryString.marketing_banner || queryString.utm_banner), (0,_define_property/* default */.Z)(_obj, cookies.M_MEDIUM, queryString.marketing_medium || queryString.utm_medium), (0,_define_property/* default */.Z)(_obj, cookies.M_CONTENT, queryString.marketing_content || queryString.utm_content), (0,_define_property/* default */.Z)(_obj, cookies.M_RETARGETING, queryString.marketing_retargeting || queryString.utm_retargeting), (0,_define_property/* default */.Z)(_obj, cookies.M_REFERRER, queryString.utm_referrer || document.referrer), (0,_define_property/* default */.Z)(_obj, cookies.M_VERTICAL, queryString.marketing_vertical || ""), (0,_define_property/* default */.Z)(_obj, cookies.M_LANDING_PAGE, window.location.origin + window.location.pathname), (0,_define_property/* default */.Z)(_obj, cookies.M_GIFT_SEND, queryString.gift_send), (0,_define_property/* default */.Z)(_obj, cookies.M_AW_GRP, queryString.aw_grp), (0,_define_property/* default */.Z)(_obj, cookies.M_AW_KW, queryString.aw_kw), (0,_define_property/* default */.Z)(_obj, cookies.M_AW_AD, queryString.aw_ad), (0,_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_CAMPAIGN, queryString.stories_campaign), (0,_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_SOURCE, queryString.stories_source), (0,_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_MEDIUM, queryString.stories_medium), (0,_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_CONTENT, queryString.stories_content), (0,_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_CAMPAIGN_DATE, queryString.stories_campaign_date), (0,_define_property/* default */.Z)(_obj, constants_service.UserCampaignType.STORIES_SLUG, queryString.stories_slug), (0,_define_property/* default */.Z)(_obj, constants_service.TemplateTypeCookie.STORIES_TEMPLATE_TYPE, queryString[constants_service.TemplateTypeCookie.STORIES_TEMPLATE_TYPE]), (0,_define_property/* default */.Z)(_obj, constants_service.StoriesCookies.MONDAY_USER_ID, queryString[constants_service.StoriesCookies.MONDAY_USER_ID]), _obj);
        // Save marketing parameters into the cookie
        setMarketingCookies(marketingCookies);
    } catch (e) {
        console.log(e);
    }
};
var saveMarketingTemplateBoardIdsCookie = function(marketingTemplateBoardIds) {
    marketingTemplateBoardIds && (0,cookies_service/* setCookie */.d8)(cookies.MARKETING_TEMPLATE_BOARD_IDS, marketingTemplateBoardIds);
};

// EXTERNAL MODULE: ./node_modules/lodash/defer.js
var defer = __webpack_require__(81629);
var defer_default = /*#__PURE__*/__webpack_require__.n(defer);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
;// CONCATENATED MODULE: ./services/performance/resources-load-tracking.js


function resources_load_tracking_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            resources_load_tracking_define_property(target, key, source[key]);
        });
    }
    return target;
}

var RESOURCES_PATTERN_TO_TRACK = [
    "globe_top_people.png",
    "use.typekit.net",
    "dynamic-template-page.js"
]; //	checking if a string is part of the resource url
var ERROR_KINDS = {
    PERFORMANCE_OBSERVER: "performance_observer",
    GET_ENTRIES_BY_TYPE: "get_entries_by_type"
};
var ResourcesLoadTracking = /*#__PURE__*/ function() {
    "use strict";
    function ResourcesLoadTracking(pageLoadUniqueId) {
        (0,_class_call_check/* default */.Z)(this, ResourcesLoadTracking);
        this.pageLoadUniqueId = pageLoadUniqueId;
    }
    (0,_create_class/* default */.Z)(ResourcesLoadTracking, [
        {
            key: "shouldTrackResource",
            value: function shouldTrackResource(url) {
                return RESOURCES_PATTERN_TO_TRACK.some(function(resource) {
                    return url.includes(resource);
                });
            }
        },
        {
            key: "handleResources",
            value: function handleResources(resources) {
                var _this = this;
                resources.forEach(function(resource) {
                    var name = resource.name, responseEnd = resource.responseEnd, responseStart = resource.responseStart, requestStart = resource.requestStart, fetchStart = resource.fetchStart, startTime = resource.startTime, transferSize = resource.transferSize;
                    if (_this.shouldTrackResource(name)) {
                        var rawResourceData = resource.toJSON();
                        BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_RESOURCES, {
                            placement: _this.pageLoadUniqueId,
                            kind: name,
                            direct_object_id: startTime,
                            info1: responseEnd,
                            info2: fetchStart,
                            info3: requestStart,
                            direct_object: responseStart,
                            board_kind: transferSize,
                            data: _object_spread({}, rawResourceData)
                        });
                    }
                });
            }
        },
        {
            key: "trackLoadedResources",
            value: function trackLoadedResources() {
                try {
                    var resources = window.performance.getEntriesByType("resource"); //	until now
                    this.handleResources(resources);
                } catch (error) {
                    this.trackError(ERROR_KINDS.GET_ENTRIES_BY_TYPE, error.message);
                }
            }
        },
        {
            key: "trackFutureResources",
            value: function trackFutureResources() {
                var _this = this;
                if (!window.PerformanceObserver) {
                    //	e.g.: not supported in IE
                    this.trackError(ERROR_KINDS.PERFORMANCE_OBSERVER, "not supported");
                    return;
                }
                try {
                    var observer = new PerformanceObserver(function(resources, observer) {
                        var resourceEntries = resources.getEntries();
                        _this.handleResources(resourceEntries);
                    });
                    observer.observe({
                        entryTypes: [
                            "resource"
                        ]
                    });
                } catch (error) {
                    this.trackError(ERROR_KINDS.PERFORMANCE_OBSERVER, error.message);
                }
            }
        },
        {
            key: "trackError",
            value: function trackError(kind, message) {
                BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_RESOURCES_ERROR, {
                    placement: this.pageLoadUniqueId,
                    data: {
                        error: message
                    },
                    kind: kind
                });
            }
        },
        {
            key: "track",
            value: function track() {
                this.trackLoadedResources();
                this.trackFutureResources();
            }
        }
    ]);
    return ResourcesLoadTracking;
}();
//	*Important notes*:
//	some browsers may be blocked, so mind values are bigger than 0
//	some resources comes from cache (0 duration and transferSize, but mind it's not 100% working so probably should clean outliers)
//	mind some resources are loaded on page load (e.g. bundles, fonts, favicon) but some after being called through other scripts
//	times relative to page load


;// CONCATENATED MODULE: ./services/performance/page-load-tracking.js


function page_load_tracking_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function page_load_tracking_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            page_load_tracking_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var PageLoadTracking = /*#__PURE__*/ function() {
    "use strict";
    function PageLoadTracking(pageLoadUniqueId) {
        (0,_class_call_check/* default */.Z)(this, PageLoadTracking);
        this.pageLoadUniqueId = pageLoadUniqueId;
    }
    (0,_create_class/* default */.Z)(PageLoadTracking, [
        {
            key: "getPaintsData",
            value: function getPaintsData() {
                var paints = window.performance.getEntriesByType("paint");
                var paintsData = {};
                if (!paints) return paintsData;
                paints.map(function(paint) {
                    var name = paint.name, startTime = paint.startTime;
                    paintsData[name] = startTime;
                });
                return paintsData;
            }
        },
        {
            key: "getPerformenceData",
            value: function getPerformenceData(data) {
                var template = data.template, navigationStart = data.navigationStart, firstPaint = data["first-paint"], domInteractive = data.domInteractive, domContentLoadedEventEnd = data.domContentLoadedEventEnd, loadEventStart = data.loadEventStart;
                return {
                    template: template,
                    firstPaint: firstPaint,
                    timeToInteractive: domInteractive - navigationStart,
                    timeToContentLoad: domContentLoadedEventEnd - navigationStart,
                    timeToToalLoad: loadEventStart - navigationStart
                };
            }
        },
        {
            key: "getInfoData",
            value: function getInfoData(performanceData) {
                var template = performanceData.template, firstPaint = performanceData.firstPaint, timeToInteractive = performanceData.timeToInteractive, timeToContentLoad = performanceData.timeToContentLoad, timeToToalLoad = performanceData.timeToToalLoad;
                return {
                    kind: template,
                    info1: firstPaint,
                    info2: timeToInteractive,
                    info3: timeToContentLoad,
                    direct_object_id: timeToToalLoad // time to total load
                };
            }
        },
        {
            key: "setPerformenceOnWindow",
            value: function setPerformenceOnWindow(performenceData) {
                window.mondayPerformence = performenceData;
            }
        },
        {
            key: "track",
            value: function track(template) {
                try {
                    var timing = window.performance.timing.toJSON();
                    var navigation = window.performance.navigation;
                    var memory = window.performance.memory; //	not supported in firefox
                    var paintsData = this.getPaintsData();
                    var data = _object_spread_props(page_load_tracking_object_spread(_object_spread_props(page_load_tracking_object_spread({}, timing), {
                        redirectCount: navigation && navigation.redirectCount
                    }), paintsData), {
                        totalJSHeapSize: memory && memory.totalJSHeapSize,
                        template: template
                    });
                    var performanceData = this.getPerformenceData(data);
                    this.setPerformenceOnWindow(performanceData);
                    var infoData = this.getInfoData(performanceData);
                    BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_DATA, _object_spread_props(page_load_tracking_object_spread({
                        data: data
                    }, infoData), {
                        placement: this.pageLoadUniqueId
                    }));
                } catch (error) {
                    BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_ERROR, {
                        data: {
                            error: error.message
                        },
                        placement: this.pageLoadUniqueId
                    });
                }
            }
        }
    ]);
    return PageLoadTracking;
}();


;// CONCATENATED MODULE: ./services/page-performance-tracking-events-service.js







var PagePerformanceEventsTracker = /*#__PURE__*/ function() {
    "use strict";
    function PagePerformanceEventsTracker() {
        (0,_class_call_check/* default */.Z)(this, PagePerformanceEventsTracker);
        this.pageLoadUniqueId = (0,utils_service.getRandomInt)(100000000);
        this.pageLoadTracking = new PageLoadTracking(this.pageLoadUniqueId);
        this.resourcesLoadTracking = new ResourcesLoadTracking(this.pageLoadUniqueId);
    }
    (0,_create_class/* default */.Z)(PagePerformanceEventsTracker, [
        {
            key: "track",
            value: function track(template) {
                try {
                    if (!window.performance) {
                        BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_NOT_SUPPORTED);
                        return;
                    }
                    this.pageLoadTracking.track(template);
                    this.resourcesLoadTracking.track();
                } catch (error) {
                    BigBrain("track", bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_GENERIC_ERROR, {
                        data: {
                            error: error.message
                        },
                        placement: this.pageLoadUniqueId
                    });
                }
            }
        }
    ]);
    return PagePerformanceEventsTracker;
}();
var trackPagePerformance = function(param) {
    var template = param.template;
    var pagePerformanceEventsTracker = new PagePerformanceEventsTracker();
    defer_default()(function() {
        return pagePerformanceEventsTracker.track(template);
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./services/cookies/extended-trial-cookies-service.js


var saveExtendTrialCookie = function() {
    var extendTrialCookie = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    extendTrialCookie.token && (0,cookies_service/* setCookie */.d8)(cookies.EXTEND_TRIAL_COOKIE_KEY, extendTrialCookie.token, {
        expires: parseInt(extendTrialCookie.daysToExpire) || cookies.EXTEND_TRIAL_COOKIE_DAYS_EXPIRE_DEFAULT
    });
};

;// CONCATENATED MODULE: ./services/platform-cookie-sync-service.js



var setSkipQuestionsCookieIfNeeded = function(skipClustersQuestion) {
    if (skipClustersQuestion) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(cookies.SKIP_CLUSTER_QUESTION, "true", {
            expires: 3
        }, bigbrain_event_types.SET_SKIP_QUESTION_COOKIE);
    }
};

;// CONCATENATED MODULE: ./services/dom-observer-service.js

var WHITELISTED_CLASSES_PATTERNS = [
    "ReactModalPortal"
];
var WHITELISTED_IDS_PATTERNS = [
    "monday_tools_extension_id",
    "batBeacon",
    "_hjRemoteVarsFrame"
];
var WHITELISTED_SRC_PATTERNS = [
    "8175736.fls.doubleclick.net",
    "comeet.com"
];
var findPatternMatchInListForAttribute = function(list, attribute) {
    return list.some(function(pattern) {
        return attribute.includes(pattern);
    });
};
var shouldSkipNode = function(node) {
    var id = node.id;
    if (id && findPatternMatchInListForAttribute(WHITELISTED_IDS_PATTERNS, id)) return true;
    var classname = node.className;
    if (classname && findPatternMatchInListForAttribute(WHITELISTED_CLASSES_PATTERNS, classname)) return true;
    var src = node.src;
    if (src && findPatternMatchInListForAttribute(WHITELISTED_SRC_PATTERNS, src)) return true;
};
var initDomObserving = function() {
    // helping tracking changes in the page. Used for analysis of chrome extension iframes
    // paused as we done using it, but keep it in the code as it might be useful in the future for more stuff
    var shouldObserve =  true && false; // always/upon draw for certain %
    if (!shouldObserve) return;
    try {
        if (!window.MutationObserver) {
            BigBrain("track", bigbrain_event_types.DOM_CHANGED_UNAVAILABLE, {
                kind: "not supporting mutation observer"
            });
            return;
        }
        var loadedAt = new Date().getTime();
        var targetNode = document.body;
        var observerConfig = {
            childList: true
        };
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes && mutation.addedNodes.forEach(function(node) {
                    try {
                        if (shouldSkipNode(node)) return;
                        window.requestAnimationFrame(function() {
                            var boundingClientRect;
                            try {
                                boundingClientRect = node.getBoundingClientRect && node.getBoundingClientRect().toJSON();
                            } catch (e) {}
                            BigBrain("track", bigbrain_event_types.DOM_CHANGED, {
                                placement: node.id,
                                kind: node.className,
                                info1: node.href,
                                info2: node.src,
                                info3: node.type,
                                direct_object_id: new Date().getTime() - loadedAt,
                                direct_object: window.visitGuid,
                                board_kind: node.nodeName,
                                data: boundingClientRect
                            });
                        });
                    } catch (e) {
                        BigBrain("track", bigbrain_event_types.DOM_CHANGE_EVENT_FAILURE, {
                            kind: e.message || "n/a"
                        });
                    }
                });
            });
        });
        observer.observe(targetNode, observerConfig);
    } catch (e) {
        BigBrain("track", bigbrain_event_types.DOM_CHANGED_UNAVAILABLE, {
            kind: e.message || "n/a"
        });
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
;// CONCATENATED MODULE: ./services/page-usage-duration-tracking.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var MAX_SECONDS = 60;
var TIMEOUT = 5 * 1000;
var TRACK_PERCENTAGE = 10;
var track = function(timeSinceStarted, scrollPercent) {
    BigBrain("track", bigbrain_event_types.PAGE_USAGE_DURATION, {
        kind: window.visitGuid,
        info1: timeSinceStarted,
        info2: scrollPercent,
        info3: location.href
    });
};
var iterateTracker = function() {
    var _ref = _async_to_generator(function(startedAt) {
        var scrollPercent, secondsSinceStarted;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,dom_utils_service.getScrollPercent)()
                    ];
                case 1:
                    scrollPercent = _state.sent();
                    secondsSinceStarted = Math.floor((new Date().getTime() - startedAt) / 1000);
                    track(secondsSinceStarted, scrollPercent);
                    if (!(MAX_SECONDS > secondsSinceStarted)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,utils_service.sleep)(TIMEOUT)
                    ];
                case 2:
                    _state.sent();
                    iterateTracker(startedAt);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function iterateTracker(startedAt) {
        return _ref.apply(this, arguments);
    };
}();
var shouldTrack = function() {
    return TRACK_PERCENTAGE > 100 * Math.random();
};
var initPageUsageDurationTracking = function(startedAt) {
    if (!shouldTrack()) return;
    iterateTracker(startedAt);
};

// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
;// CONCATENATED MODULE: ./services/bigbrain-visitor-experiment-sync-service.js




var fireBigbrainVisitorExperimentSyncEvent = function() {
    var experimentId = (0,cookies_service/* getCookie */.ej)(cookies.EXPERIMENT_VISITOR_ID);
    if (experimentId) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.WEBSITE_SYNC_VISITOR_AND_AB_TEST_EXPERIMENT_ID, {
            kind: experimentId
        });
    }
};

;// CONCATENATED MODULE: ./services/header-scripts-service.js













var initHeaderScripts = function initHeaderScripts(param) {
    var coupon = param.coupon, extendTrialCookie = param.extendTrialCookie, marketingTemplateBoardIds = param.marketingTemplateBoardIds, clusterId = param.clusterId, subClusterId = param.subClusterId, clusterIdSource = param.clusterIdSource, subClusterIdSource = param.subClusterIdSource, localeId = param.localeId, template = param.template, skipClustersQuestion = param.skipClustersQuestion, enablePageUsageDurationTracking = param.enablePageUsageDurationTracking, isProduction = param.isProduction;
    var startedAt = new Date().getTime();
    saveMarketingCookies();
    saveCouponCookie(coupon);
    saveExtendTrialCookie(extendTrialCookie);
    saveMarketingTemplateBoardIdsCookie(marketingTemplateBoardIds);
    (0,clusters_service/* setClusterIdIfNeeded */.lc)(clusterId, subClusterId, {
        sendBigBrainEvent: true
    });
    (0,clusters_service/* setClusterForUser */.PH)(clusterId, types.CLUSTER_TYPE, clusterIdSource);
    (0,clusters_service/* setClusterForUser */.PH)(subClusterId, types.USE_CASE_TYPE, subClusterIdSource, {
        parent_cluster_id: clusterId
    }); //currently sub-cluster available only when setting also cluster
    setLocaleIdIfNeeded(localeId, {
        sendBigBrainEvent: true
    });
    setSkipQuestionsCookieIfNeeded(skipClustersQuestion);
    fireBigbrainVisitorExperimentSyncEvent();
    initDomObserving();
    if (isProduction && enablePageUsageDurationTracking) {
        initPageUsageDurationTracking(startedAt);
    }
    window.addEventListener("load", function() {
        trackPagePerformance({
            template: template
        });
    });
    (router_default()).onRouteChangeComplete = function(url) {
        trackPageView(url, clusterId, subClusterId);
    }; //Track changes on client routing
};
var trackPageView = function trackPageView(url, clusterId, subClusterId) {
    (0,bigbrain_service.trackBigBrainPageView)(url, clusterId, subClusterId);
};

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./components/core/head/polyfills.js






function polyfills_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var Polyfills = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Polyfills, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Polyfills);
    function Polyfills() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, Polyfills);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        polyfills_define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderClosestPolyfill", function() {
            return "\n      if (!Element.prototype.matches) {\n        Element.prototype.matches = Element.prototype.msMatchesSelector || \n                                    Element.prototype.webkitMatchesSelector;\n        }\n        \n      if (!Element.prototype.closest) {\n        Element.prototype.closest = function(s) {\n          var el = this;\n      \n          do {\n            if (el.matches(s)) return el;\n            el = el.parentElement || el.parentNode;\n          } while (el !== null && el.nodeType === 1);\n          return null;\n        };\n      }";
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Polyfills, [
        {
            //to add a new polyfill just add a new script tag inside the fragment
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: this.renderClosestPolyfill()
                        }
                    })
                });
            }
        }
    ]);
    return Polyfills;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/head/use-resource-performance-tracking.js

var useResourcePerformanceTracking = function(resourceName, onLoadComplete) {
    var ref = (0,react.useState)(null), resource = ref[0], setResource = ref[1];
    var observer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var _window;
        if (!((_window = window) === null || _window === void 0 ? void 0 : _window.PerformanceObserver)) {
            return;
        }
        observer.current = new PerformanceObserver(function(list) {
            var entry = list.getEntries().find(function(performanceEntry) {
                return performanceEntry.name.includes(resourceName);
            });
            if (entry) {
                onLoadComplete && onLoadComplete(entry.duration, entry.startTime, entry.transferSize);
                setResource(entry);
            }
        });
        observer.current.observe({
            type: "resource",
            buffered: true
        });
        return function() {
            observer.current.disconnect();
        };
    }, [
        onLoadComplete,
        resourceName
    ]);
    (0,react.useEffect)(function() {
        resource && observer.current.disconnect();
    }, [
        resource
    ]);
};
/* harmony default export */ var use_resource_performance_tracking = (useResourcePerformanceTracking);

;// CONCATENATED MODULE: ./components/core/head/dynamic-template-page-script-performance-tracker.js




var BUNDLE_SCRIPT_PREFIX = "dynamic-template-page";
var DynamicTemplatePageScriptPerformanceTracker = function() {
    var onLoadComplete = (0,react.useCallback)(function(loadingDurationTime, startTime, size) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.PAGE_PERFORMANCE_TRACKING_RESOURCES, {
            kind: "".concat(BUNDLE_SCRIPT_PREFIX, " monitor"),
            info1: loadingDurationTime,
            info2: startTime,
            info3: size
        });
    }, []);
    use_resource_performance_tracking(BUNDLE_SCRIPT_PREFIX, onLoadComplete);
    return null;
};
/* harmony default export */ var dynamic_template_page_script_performance_tracker = (DynamicTemplatePageScriptPerformanceTracker);

// EXTERNAL MODULE: ./constants/localstorage.js
var localstorage = __webpack_require__(50663);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./components/core/head/landing-page-tracker.js



var LandingPageTracker = function() {
    (0,react.useEffect)(function() {
        if ((0,general/* isServerSide */.s$)()) {
            return;
        }
        var landingPage = window.location.pathname;
        // don't store landing page if it exists already
        if (localStorage.getItem(localstorage.LANDING_PAGE)) return;
        localStorage.setItem(localstorage.LANDING_PAGE, JSON.stringify({
            value: landingPage,
            timestamp: Date.now()
        }));
    }, []);
    return null;
};
/* harmony default export */ var landing_page_tracker = (LandingPageTracker);

// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./services/ab-tests/lp-ab-tests-service.js
var lp_ab_tests_service = __webpack_require__(36233);
// EXTERNAL MODULE: ./components/core/head/bigbrain-script.js + 1 modules
var bigbrain_script = __webpack_require__(36403);
;// CONCATENATED MODULE: ./components/core/head/header-scripts-component.js
















var isProduction = "production" === "production";
var HeaderScriptsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HeaderScriptsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HeaderScriptsComponent);
    function HeaderScriptsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HeaderScriptsComponent);
        var _this;
        _this = _super.call(this, props);
        var abTests = props.abTests, abTestExactEventName = props.abTestExactEventName;
        _this.exactPageAbTest = _this.getGenericAbTest(abTests, abTestExactEventName);
        return _this;
    }
    (0,_create_class/* default */.Z)(HeaderScriptsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, coupon = _props.coupon, extendTrialCookie = _props.extendTrialCookie, marketingTemplateBoardIds = _props.marketingTemplateBoardIds, clusterId = _props.clusterId, subClusterId = _props.subClusterId, clusterIdSource = _props.clusterIdSource, pageProductId = _props.pageProductId, subClusterIdSource = _props.subClusterIdSource, localeId = _props.localeId, template = _props.template, skipClustersQuestion = _props.skipClustersQuestion, enablePageUsageDurationTracking = _props.enablePageUsageDurationTracking, customHeadScript = _props.customHeadScript;
                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).META_DATA, {
                    page_type: pageProductId
                });
                initHeaderScripts({
                    isProduction: isProduction,
                    coupon: coupon,
                    marketingTemplateBoardIds: marketingTemplateBoardIds,
                    clusterId: clusterId,
                    subClusterId: subClusterId,
                    localeId: localeId,
                    extendTrialCookie: extendTrialCookie,
                    template: template,
                    skipClustersQuestion: skipClustersQuestion,
                    enablePageUsageDurationTracking: enablePageUsageDurationTracking,
                    clusterIdSource: clusterIdSource,
                    subClusterIdSource: subClusterIdSource
                });
            }
        },
        {
            key: "getGenericAbTest",
            value: function getGenericAbTest(abTests, abTestExactEventName) {
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTests);
                return abTestExactEventName && abTestVariant && {
                    name: abTestExactEventName,
                    variant: abTestVariant
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, pageType = _props.pageType, template = _props.template, clusterId = _props.clusterId, subClusterId = _props.subClusterId, customHeadScript = _props.customHeadScript, segmentsList = _props.segmentsList, pageProductId = _props.pageProductId;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bigbrain_script/* default */.Z, {
                            isProduction: isProduction,
                            pageType: pageType,
                            template: template,
                            clusterId: clusterId,
                            subClusterId: subClusterId,
                            segmentsList: segmentsList,
                            pageProductId: pageProductId,
                            exactPageAbTest: this.exactPageAbTest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamic_template_page_script_performance_tracker, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_page_tracker, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Polyfills, {}),
                        customHeadScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            dangerouslySetInnerHTML: {
                                __html: customHeadScript
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return HeaderScriptsComponent;
}(react.PureComponent);
/* harmony default export */ var header_scripts_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(HeaderScriptsComponent)));


/***/ }),

/***/ 62210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var PRECONNECT_DOMAINS = [
    "https://dapulse-res.cloudinary.com"
];
// we add all preconnect domains to dns-prefetch as a fallback.
var DNS_PREFETCH_DOMAINS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(PRECONNECT_DOMAINS);
var PreconnectLinksComponent = function() {
    return [
        PRECONNECT_DOMAINS.map(function(link, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: link
            }, index);
        }),
        DNS_PREFETCH_DOMAINS.map(function(link, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "dns-prefetch",
                href: link
            }, index);
        })
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (PreconnectLinksComponent);


/***/ }),

/***/ 40221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var client_services_signup_prefetch_signup_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95315);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65023);
/* harmony import */ var services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65488);
/* harmony import */ var constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83139);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SignupPrefetchedAssetsLinksComponent = function() {
    var allPrefetchedSignupAssets = (0,client_services_signup_prefetch_signup_service__WEBPACK_IMPORTED_MODULE_1__/* .usePrefetchedSignupAssets */ .n)();
    var numberOfLinksSuccessfullyPrefetched = 0;
    var dnsPrefetchedDomains = allPrefetchedSignupAssets.filter(function(asset) {
        return asset.type === constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREFETCH_TYPES.DNS_PREFETCH */ .DO.DNS_PREFETCH;
    });
    var preConnectedDomains = allPrefetchedSignupAssets.filter(function(asset) {
        return asset.type === constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREFETCH_TYPES.PRECONNECT */ .DO.PRECONNECT;
    });
    var prefetchedSignupAssets = allPrefetchedSignupAssets.filter(function(asset) {
        return asset.type === constants_prefetch_constants__WEBPACK_IMPORTED_MODULE_3__/* .PREFETCH_TYPES.PREFETCH */ .DO.PREFETCH;
    });
    var totalNumberOfAssetsToBePrefetched = prefetchedSignupAssets === null || prefetchedSignupAssets === void 0 ? void 0 : prefetchedSignupAssets.length;
    var PREFETCHED_LINK_ID = function(index) {
        return "prefetched_link_".concat(index);
    };
    var onLinkRendered = function(param) {
        var href = param.href, index = param.index;
        try {
            // setTimeout needed to ensure it's not run synchronously, and link elements were already rendered in the DOM
            setTimeout(function() {
                var linkElement = document.querySelector("link[id=".concat(PREFETCHED_LINK_ID(index), "]"));
                if (linkElement) {
                    linkElement.onload = function() {
                        (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_4__.PREFETCH_ASSET_COMPLETED, {
                            kind: href,
                            info1: index,
                            info2: numberOfLinksSuccessfullyPrefetched++,
                            info3: totalNumberOfAssetsToBePrefetched
                        });
                        if (numberOfLinksSuccessfullyPrefetched === totalNumberOfAssetsToBePrefetched) {
                            (0,services_bigbrain_service__WEBPACK_IMPORTED_MODULE_2__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_4__.PREFETCH_ALL_ASSETS_COMPLETED, {
                                info3: totalNumberOfAssetsToBePrefetched
                            });
                        }
                    };
                    linkElement.onerror = function() {
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT("Prefetch of the following asset failed: ".concat(href));
                    };
                } else {
                    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureMessage */ .uT("Couldn't query link with id: ".concat(PREFETCHED_LINK_ID(index), " and href: ").concat(href));
                }
            });
        } catch (e) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb(e);
        }
    };
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map(function(prefetchedDomain, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index);
        }),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map(function(preConnectedDomain, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            }, index);
        }),
        prefetchedSignupAssets === null || prefetchedSignupAssets === void 0 ? void 0 : prefetchedSignupAssets.map(function(prefetchedAsset, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                id: PREFETCHED_LINK_ID(index),
                rel: prefetchedAsset.type,
                href: prefetchedAsset.href,
                onLoad: onLinkRendered(_object_spread_props(_object_spread({}, prefetchedAsset), {
                    index: index
                }))
            }, index);
        })
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (SignupPrefetchedAssetsLinksComponent);


/***/ }),

/***/ 35061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M9": function() { return /* binding */ BOLD_BLUE; },
  "LG": function() { return /* binding */ LG; },
  "MD": function() { return /* binding */ MD; },
  "SM": function() { return /* binding */ SM; },
  "Cj": function() { return /* binding */ WHITE; },
  "XS": function() { return /* binding */ XS; },
  "Mp": function() { return /* binding */ XXS; },
  "ZP": function() { return /* binding */ ButtonComponent; }
});

// UNUSED EXPORTS: BLUE, FULL, IRIS, MINT_GREEN

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-arrow/button-arrow.js + 1 modules
var button_arrow = __webpack_require__(37759);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/new-button/button-component.scss.js




var getButtonTheme = function(color) {
    return "\n      &:not(.outline) {\n        background-color: ".concat(color, ";\n\n        &:hover {\n          background-color: darken(").concat(color, ", 5%);\n        }\n      }\n\n      &.outline {\n        color: ").concat(color, ";\n        border: 1px solid ").concat(color, " !important;\n        transition: background-color 200ms ease, color 200ms ease;\n\n        &:hover {\n          color: ").concat(colors/* default.white */.Z.white, " !important;\n          background-color: ").concat(color, ";\n          &.white {\n            color: ").concat(colors/* default.black */.Z.black, " !important;\n          }\n        }\n      }\n");
};
var StyledButtonComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "epmjo5x0"
})("display:inline-block;border-radius:100px;cursor:pointer;font-weight:300;user-select:none;transition:background-color 200ms ease;", function(param) {
    var accessibleColor = param.accessibleColor;
    return '\n  &[data-button-color="'.concat(accessibleColor, '"] {\n              &:not(.outline) {\n                background: ').concat(colors/* default */.Z[accessibleColor], ";\n                &:hover {\n                  background-color: ").concat((0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[accessibleColor]), ";\n                  &.white {\n                    background-color: ").concat(colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME], ";\n                  }\n                }\n              }\n            }\n  ");
}, "  &:hover{outline:0;}&.disabled{background-color:", colors/* default.dark-marble */.Z["dark-marble"], " !important;color:", colors/* default.brand-gray */.Z["brand-gray"], " !important;pointer-events:none;}// default size:md\n  font-size:0.8125rem;padding:12px 24px;&.with-arrow{padding-right:16px;}&.with-left-icon{height:40px;display:flex;align-items:center;}&.sm{font-size:0.6875rem;padding:8px 16px;&.with-arrow{padding-right:12px;}}&.md{font-size:0.8125rem;padding:12px 24px;&.min-padding{padding-right:10px;padding-left:10px;}&.with-arrow{padding-right:16px;}}&.lg{font-size:0.875rem;padding:16px 32px;&.with-arrow{padding-left:30px;padding-right:20px;}}&.full{font-size:0.875rem;padding:16px 0;width:100%;text-align:center;}&.blue{", getButtonTheme("#0085ff"), "}&.mint-green{", getButtonTheme("#25dbc5"), "}&.bold-blue{", getButtonTheme("#15bbe4"), "}&.purple{", getButtonTheme("#a358df"), "}&.iris{", getButtonTheme("#595ad4"), "}&.riverstone{", getButtonTheme("#f5f6f8"), "}&.royal{", getButtonTheme("#597bfc"), "}&.green{", getButtonTheme("#00ca72"), "}&.orange{", getButtonTheme("#fdab3d"), "}&.yellow{", getButtonTheme("#ffcb00"), "}&.pink{", getButtonTheme("#ff0476"), "}&.marketing-red-dark{", getButtonTheme("#ca0c6b"), "}&.dev-green-dark{", getButtonTheme("#037f4c"), "}&.projects-orange-dark{", getButtonTheme("#f86700"), "}&.crm-green-dark{", getButtonTheme("#00a0a0"), "}&.workos-iris{", getButtonTheme("#6161ff"), "}&.dark-color{", getButtonTheme("#181b34"), "}&.brand-wm-primary-color{", getButtonTheme("#6161ff"), "}&.crm-dark-tint-01{", getButtonTheme("#00889b"), "}&.brand-green-dark-tint-01{", getButtonTheme("#00854d"), "}&.white{", getButtonTheme("#ffffff"), "}&.black{", getButtonTheme("#000000"), "}&.workforms-red{", getButtonTheme("#c21e71"), "}&.service-dark-color{", getButtonTheme("#980131"), "}");

;// CONCATENATED MODULE: ./components/core/new-button/button-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








// BUTTON SIZES
var XXS = "xxs";
var XS = "xs";
var SM = "sm";
var MD = "md";
var LG = "lg";
var FULL = "full";
// BUTTON COLORS
var BLUE = "blue";
var MINT_GREEN = "mint-green";
var BOLD_BLUE = "bold-blue";
var WHITE = "white";
var IRIS = "iris";
var ButtonComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ButtonComponent);
    function ButtonComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ButtonComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onClick", function(e) {
            var _props = _this.props, onClick = _props.onClick, disabled = _props.disabled;
            e === null || e === void 0 ? void 0 : e.target.blur(); //remove focus on mouse click
            if (disabled) return;
            onClick(e);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "linkWrapper", function(children) {
            var _props = _this.props, isOpenLinkInNewTab = _props.isOpenLinkInNewTab, seoFriendlyUrl = _props.seoFriendlyUrl;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: seoFriendlyUrl,
                target: isOpenLinkInNewTab ? "_blank" : "_self",
                children: children
            });
        });
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.onClick);
        _this.state = {
            isHovered: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ButtonComponent, [
        {
            key: "getComponentInlineStyles",
            value: function getComponentInlineStyles() {
                var _props = this.props, outline = _props.outline, color = _props.color, textColor = _props.textColor;
                return {
                    color: outline ? colors/* default */.Z[color] : textColor
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, children = _props.children, className = _props.className, color = _props.color, size = _props.size, outline = _props.outline, disabled = _props.disabled, isWithArrow = _props.isWithArrow, iconRenderer = _props.iconRenderer, seoFriendlyUrl = _props.seoFriendlyUrl, minPadding = _props.minPadding;
                var isHovered = this.state.isHovered;
                var inlineComponentStyles = this.getComponentInlineStyles();
                var accessibleColor = (0,accessibility_service/* getAccessibleButtonColor */.ef)(color);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                    condition: !!seoFriendlyUrl,
                    wrapper: this.linkWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonComponent, {
                        accessibleColor: accessibleColor,
                        className: classnames_default()("button-component", className, size, accessibleColor, {
                            outline: outline,
                            disabled: disabled,
                            "with-arrow": isWithArrow,
                            "min-padding": minPadding,
                            "with-left-icon": iconRenderer != null
                        }),
                        onClick: this.onClick,
                        style: inlineComponentStyles,
                        onKeyDown: this.onKeyDown,
                        tabIndex: disabled ? -1 : 0,
                        role: "button",
                        onMouseEnter: function() {
                            return _this.setState({
                                isHovered: true
                            });
                        },
                        onMouseLeave: function() {
                            return _this.setState({
                                isHovered: false
                            });
                        },
                        "data-button-color": accessibleColor,
                        children: [
                            iconRenderer && iconRenderer(),
                            children,
                            isWithArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_arrow/* default */.Z, {
                                size: size,
                                hover: isHovered
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ButtonComponent;
}(react.PureComponent);

ButtonComponent.defaultProps = {
    className: "",
    color: BLUE,
    size: MD,
    outline: false,
    textColor: colors/* default.white */.Z.white,
    iconRenderer: null,
    minPadding: false,
    disabled: false
};


/***/ }),

/***/ 89548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CK": function() { return /* binding */ StyledStickyHeaderWrapper; },
/* harmony export */   "NK": function() { return /* binding */ StyledAccessibilityWrapper; },
/* harmony export */   "es": function() { return /* binding */ StyledTemplateContentWrapper; }
/* harmony export */ });
/* unused harmony export StyledContactSalesStickyButtonWrapper */
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var constants_z_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35257);
/* harmony import */ var _constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698);



var StyledContactSalesStickyButtonWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "e1jq9k1o0"
})("position:fixed;top:80vh;right:0;width:230px;z-index:", ALWAYS_ON_TOP, ";")));
var StyledTemplateContentWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1jq9k1o1"
})("position:relative;z-index:", constants_z_index__WEBPACK_IMPORTED_MODULE_2__/* .BASE_TEMPLATE_ROOT */ .jP, ";&.with-background-color{background-color:white;}");
var StyledAccessibilityWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1jq9k1o2"
})("position:relative;z-index:", constants_z_index__WEBPACK_IMPORTED_MODULE_2__/* .BASE_TEMPLATE_ROOT */ .jP + 1, ";");
var StyledStickyHeaderWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e1jq9k1o3"
})("position:fixed;bottom:20vh;right:5vw;z-index:", constants_z_index__WEBPACK_IMPORTED_MODULE_2__/* .ALWAYS_ON_TOP */ .OL, ";opacity:0;@media (max-width:", _constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px){right:40px;}&.show-sticky-header{opacity:1;}");


/***/ }),

/***/ 79409:
/***/ (function(module) {


var ALIGN_TYPES = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right"
};
var ALIGN_LABELS = {
    LEFT: "Left",
    CENTER: "Center",
    RIGHT: "Right"
};
var VERTICAL_ALIGN_LABELS = {
    TOP: "Top",
    CENTER: "Center",
    BOTTOM: "Bottom"
};
module.exports = {
    ALIGN_TYPES: ALIGN_TYPES,
    ALIGN_LABELS: ALIGN_LABELS,
    VERTICAL_ALIGN_LABELS: VERTICAL_ALIGN_LABELS
};


/***/ }),

/***/ 53219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ FOOTER_ID; },
/* harmony export */   "k": function() { return /* binding */ MAIN_ID; }
/* harmony export */ });
var MAIN_ID = "main";
var FOOTER_ID = "footer";


/***/ }),

/***/ 83139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ PREFETCH_TYPES; }
/* harmony export */ });
/* unused harmony exports PLATFORM_CDN_URL, PLATFORM_DOMAIN, PLATFORM_BUNDLES_ENDPOINT, PLATFORM_BUNDLES_ASSETS_TO_FETCH */
var PREFETCH_TYPES = {
    DNS_PREFETCH: "dns-prefetch",
    PREFETCH: "prefetch",
    PRECONNECT: "preconnect"
};
var isProduction = "production" === "production";
var PLATFORM_STAGING_CDN_URL = "https://multicdn.mondaystaging.com";
var PLATFORM_PROD_CDN_URL = "https://cdn.monday.com";
var PLATFORM_CDN_URL = (/* unused pure expression or super */ null && (isProduction ? PLATFORM_PROD_CDN_URL : PLATFORM_STAGING_CDN_URL));
var PLATFORM_DOMAIN = isProduction ? "monday.com" : "mondaystaging.com";
var PLATFORM_BUNDLES_ENDPOINT = "https://auth.".concat(PLATFORM_DOMAIN, "/layout/get_bundles_data");
var PLATFORM_BUNDLES_ASSETS_TO_FETCH = (/* unused pure expression or super */ null && ([
    "soft_signup",
    "signup",
    "signup-mobile",
    "main",
    "components",
    "vendors",
    "externals"
]));


/***/ }),

/***/ 42349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ TIERS_STICKY_HEADER_OFFSET; },
/* harmony export */   "I$": function() { return /* binding */ TIER_CARD_PRICE_HEIGHT; },
/* harmony export */   "TR": function() { return /* binding */ CLEAN_FIRST_FOLD_MARGIN; },
/* harmony export */   "Ww": function() { return /* binding */ TIER_CARD_VIDEO_WIDTH; },
/* harmony export */   "ld": function() { return /* binding */ TIERS_STICKY_HEADER_BORDER_OFFSET; },
/* harmony export */   "m6": function() { return /* binding */ TIER_CARD_VIDEO_HEIGHT; },
/* harmony export */   "pP": function() { return /* binding */ PLANS_COMPONENT_WIDTH; }
/* harmony export */ });
/* unused harmony exports PLANS_HEADERS_OFFSET, FREE_TIER_PRICE_HEIGHT */
var HEADER_HEIGHT = 72;
var PLANS_HEADERS_OFFSET = (/* unused pure expression or super */ null && (HEADER_HEIGHT));
var TIERS_STICKY_HEADER_OFFSET = HEADER_HEIGHT;
var TIERS_STICKY_HEADER_BORDER_OFFSET = 107; // sticky header height (82) + first title height (25)
var PLANS_COMPONENT_WIDTH = 1225;
var TIER_CARD_PRICE_HEIGHT = 128;
var FREE_TIER_PRICE_HEIGHT = 142;
var TIER_CARD_VIDEO_WIDTH = 422;
var TIER_CARD_VIDEO_HEIGHT = 284;
var CLEAN_FIRST_FOLD_MARGIN = "10%";


/***/ }),

/***/ 78803:
/***/ (function(module) {


var VERSION_9 = "9";
var VERSION_10 = "10";
var VERSION_11 = "11";
var VERSION_12 = "12";
var VERSION_13 = "13";
var DEFAULT_VERSION = VERSION_13;
var ALLOWED_VERSIONS = [
    VERSION_9,
    VERSION_10,
    VERSION_11,
    VERSION_12,
    VERSION_13
];
module.exports = {
    VERSION_9: VERSION_9,
    VERSION_10: VERSION_10,
    VERSION_11: VERSION_11,
    VERSION_12: VERSION_12,
    VERSION_13: VERSION_13,
    DEFAULT_VERSION: DEFAULT_VERSION,
    ALLOWED_VERSIONS: ALLOWED_VERSIONS
};


/***/ }),

/***/ 55674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F3": function() { return /* binding */ FREE_TIER_2021_SEATS_LIMIT; },
/* harmony export */   "F_": function() { return /* binding */ NUM_DEFAULT_DISPLAYED_PLANS; },
/* harmony export */   "Iy": function() { return /* binding */ TIERS; },
/* harmony export */   "Jb": function() { return /* binding */ PERIOD_TEXTS; },
/* harmony export */   "U1": function() { return /* binding */ FEATURES_IDS; },
/* harmony export */   "Us": function() { return /* binding */ PLAN_INFO_SEGMENT_NAME; },
/* harmony export */   "ck": function() { return /* binding */ SUPPORTED_CURRENCIES; },
/* harmony export */   "fY": function() { return /* binding */ MAX_TEAM_SIZE; },
/* harmony export */   "no": function() { return /* binding */ FREE_TIER_2022_SEATS_LIMIT; },
/* harmony export */   "yv": function() { return /* binding */ ORDERED_PERIOD_NAMES; },
/* harmony export */   "z5": function() { return /* binding */ PERIODS; }
/* harmony export */ });
/* unused harmony exports PLATFORM_PERIODS, STANDARD_DASHBOARDS_AMOUNT, PRO_DASHBOARDS_AMOUNT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var TIERS = {
    FREE: "free",
    BASIC: "basic",
    STANDARD: "standard",
    PRO: "pro",
    ENTERPRISE: "enterprise"
};
var PERIODS = {
    yearly: "yearly",
    monthly: "monthly"
};
var _obj;
var PLATFORM_PERIODS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PERIODS.yearly, "YearlyPlan"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, PERIODS.monthly, "MonthlyPlan"), _obj);
var _obj1;
var PERIOD_TEXTS = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, PERIODS.yearly, {
    billed: "pricingPage.periods.yearly.billed",
    displayName: "pricingPage.periods.yearly.displayName"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj1, PERIODS.monthly, {
    billed: "pricingPage.periods.monthly.billed",
    displayName: "pricingPage.periods.monthly.displayName"
}), _obj1);
var FEATURES_IDS = {
    STORAGE: "STORAGE"
};
var PLAN_INFO_SEGMENT_NAME = "PlanInfo";
var MAX_TEAM_SIZE = "200+";
var ORDERED_PERIOD_NAMES = [
    PERIODS.yearly,
    PERIODS.monthly
];
var STANDARD_DASHBOARDS_AMOUNT = 3;
var PRO_DASHBOARDS_AMOUNT = 10;
var NUM_DEFAULT_DISPLAYED_PLANS = 4;
var FREE_TIER_2021_SEATS_LIMIT = 2;
var FREE_TIER_2022_SEATS_LIMIT = 5;
var SUPPORTED_CURRENCIES = [
    {
        name: "usd",
        currencySign: "$",
        currencyShortText: "USD",
        shouldDisplayText: true
    },
    {
        name: "euro",
        currencySign: "€",
        currencyShortText: "EUR",
        shouldDisplayText: false
    },
    {
        name: "cad",
        currencySign: "$",
        currencyShortText: "CAD",
        shouldDisplayText: true
    },
    {
        name: "gbp",
        currencySign: "\xa3",
        currencyShortText: "GBP",
        shouldDisplayText: false
    },
    {
        name: "aud",
        currencySign: "$",
        currencyShortText: "AUD",
        shouldDisplayText: true
    },
    {
        name: "mxn",
        currencySign: "$",
        currencyShortText: "MXN",
        shouldDisplayText: true
    },
    {
        name: "brl",
        currencySign: "R$",
        currencyShortText: "BRL",
        shouldDisplayText: false
    },
    {
        name: "inr",
        currencySign: "₹",
        currencyShortText: "INR",
        shouldDisplayText: false
    },
    {
        name: "jpy",
        currencySign: "\xa5",
        currencyShortText: "JPY",
        shouldDisplayText: false
    }
];


/***/ }),

/***/ 78217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": function() { return /* binding */ ENTERPRISE_TIER_VALUE_FEATURES; },
/* harmony export */   "b5": function() { return /* binding */ STUDENT_PLAN_VALUE_FEATURES; },
/* harmony export */   "cN": function() { return /* binding */ BASIC_TIER_VALUE_FEATURES; },
/* harmony export */   "kh": function() { return /* binding */ STANDARD_TIER_VALUE_FEATURES; },
/* harmony export */   "tE": function() { return /* binding */ PRO_TIER_VALUE_FEATURES; },
/* harmony export */   "tL": function() { return /* binding */ FREE_TIER_VALUE_FEATURES; }
/* harmony export */ });
/* harmony import */ var constants_pricing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55674);
/* harmony import */ var _value_features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49127);


var FREE_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UP_TO_X_TEAM_MEMBERS(constants_pricing__WEBPACK_IMPORTED_MODULE_0__/* .FREE_TIER_2021_SEATS_LIMIT */ .F3),
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE
];
var BASIC_TIER_VALUE_FEATURES = function(param) {
    var hasFreeTier = param.hasFreeTier;
    if (hasFreeTier) {
        return [
            _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_ITEMS,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.FIVE_GB_STORAGE,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIORITISED_CUSTOMER_SUPPORT,
            _value_features__WEBPACK_IMPORTED_MODULE_1__.SINGLE_DASHBOARD
        ];
    }
    return [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.SINGLE_DASHBOARD
    ];
};
var STANDARD_TIER_VALUE_FEATURES = function(param) {
    var withoutBasic = param.withoutBasic, hasFreeTier = param.hasFreeTier;
    return withoutBasic ? hasFreeTier ? [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_ITEMS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIORITISED_CUSTOMER_SUPPORT,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS
    ] : [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_DOCS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE
    ] : [
        _value_features__WEBPACK_IMPORTED_MODULE_1__.TIMELINE_AND_GANTT_VIEWS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.CALENDAR,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.GUESTS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_AUTOMATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_INTEGRATIONS,
        _value_features__WEBPACK_IMPORTED_MODULE_1__.STANDARD_DASHBOARDS
    ];
};
var PRO_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRIVATE_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.CHART_VIEW,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.TIME_TRACKING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.FORMULA,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.DEPENDENCY,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_AUTOMATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_INTEGRATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PRO_DASHBOARDS
];
var STUDENT_PLAN_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_BOARDS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.OVER_200_TEMPLATES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.COLUMN_TYPES,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.UNLIMITED_VIEWERS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MOBILE,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.CHART_VIEW
];
var ENTERPRISE_TIER_VALUE_FEATURES = [
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_SCALE_AUTOMATIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_GRADE_SECURITY,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ADVANCED_REPORTING,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.MULTI_LEVEL_PERMISSIONS,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.PREMIUM_SUPPORT,
    _value_features__WEBPACK_IMPORTED_MODULE_1__.ENTERPRISE_DASHBOARDS
];


/***/ }),

/***/ 49127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ADOBE_CREATIVE_CLOUD_PLUGIN": function() { return /* binding */ ADOBE_CREATIVE_CLOUD_PLUGIN; },
/* harmony export */   "ADVANCED_FORMULA_CAPABILITIES": function() { return /* binding */ ADVANCED_FORMULA_CAPABILITIES; },
/* harmony export */   "ADVANCED_PERMISSIONS": function() { return /* binding */ ADVANCED_PERMISSIONS; },
/* harmony export */   "ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT": function() { return /* binding */ ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT; },
/* harmony export */   "ADVANCED_REPORTING": function() { return /* binding */ ADVANCED_REPORTING; },
/* harmony export */   "ADVANCED_REPORTS": function() { return /* binding */ ADVANCED_REPORTS; },
/* harmony export */   "AGILE_REPORTING": function() { return /* binding */ AGILE_REPORTING; },
/* harmony export */   "API_ACCESS": function() { return /* binding */ API_ACCESS; },
/* harmony export */   "ASSETS_AND_FILE_MANAGEMENT": function() { return /* binding */ ASSETS_AND_FILE_MANAGEMENT; },
/* harmony export */   "BASIC_ANALYTICS_AND_DASHBOARDS": function() { return /* binding */ BASIC_ANALYTICS_AND_DASHBOARDS; },
/* harmony export */   "BOARD_PERMISSIONS": function() { return /* binding */ BOARD_PERMISSIONS; },
/* harmony export */   "BUILT_IN_WORKOCS": function() { return /* binding */ BUILT_IN_WORKOCS; },
/* harmony export */   "CALENDAR": function() { return /* binding */ CALENDAR; },
/* harmony export */   "CALENDAR_SYNC": function() { return /* binding */ CALENDAR_SYNC; },
/* harmony export */   "CAMPAIGN_MANAGEMENT": function() { return /* binding */ CAMPAIGN_MANAGEMENT; },
/* harmony export */   "CHART_VIEW": function() { return /* binding */ CHART_VIEW; },
/* harmony export */   "COLUMN_TYPES": function() { return /* binding */ COLUMN_TYPES; },
/* harmony export */   "COMMUNICATION_WITH_CONTEXT": function() { return /* binding */ COMMUNICATION_WITH_CONTEXT; },
/* harmony export */   "CUSTOMIZED_NOTIFICATIONS": function() { return /* binding */ CUSTOMIZED_NOTIFICATIONS; },
/* harmony export */   "CUSTOM_NOTIFICATIONS_AND_REMINDERS": function() { return /* binding */ CUSTOM_NOTIFICATIONS_AND_REMINDERS; },
/* harmony export */   "DEADLINE_MANAGEMENT": function() { return /* binding */ DEADLINE_MANAGEMENT; },
/* harmony export */   "DEPENDENCY": function() { return /* binding */ DEPENDENCY; },
/* harmony export */   "DEV_FEEDBACK_FORMS": function() { return /* binding */ DEV_FEEDBACK_FORMS; },
/* harmony export */   "DEV_TEMPLATES": function() { return /* binding */ DEV_TEMPLATES; },
/* harmony export */   "DOCUMENT_MANAGEMENT": function() { return /* binding */ DOCUMENT_MANAGEMENT; },
/* harmony export */   "EMAIL_INTEGRATION": function() { return /* binding */ EMAIL_INTEGRATION; },
/* harmony export */   "ENTERPRISE_DASHBOARDS": function() { return /* binding */ ENTERPRISE_DASHBOARDS; },
/* harmony export */   "ENTERPRISE_GRADE_SECURITY": function() { return /* binding */ ENTERPRISE_GRADE_SECURITY; },
/* harmony export */   "ENTERPRISE_INTEGRATIONS": function() { return /* binding */ ENTERPRISE_INTEGRATIONS; },
/* harmony export */   "ENTERPRISE_SCALE_AUTOMATIONS": function() { return /* binding */ ENTERPRISE_SCALE_AUTOMATIONS; },
/* harmony export */   "ENTERPRISE_SPECIFIC_INTEGRATIONS": function() { return /* binding */ ENTERPRISE_SPECIFIC_INTEGRATIONS; },
/* harmony export */   "FILE_MANAGEMENT": function() { return /* binding */ FILE_MANAGEMENT; },
/* harmony export */   "FILTERS": function() { return /* binding */ FILTERS; },
/* harmony export */   "FIVE_GB_STORAGE": function() { return /* binding */ FIVE_GB_STORAGE; },
/* harmony export */   "FORMS": function() { return /* binding */ FORMS; },
/* harmony export */   "FORMULA": function() { return /* binding */ FORMULA; },
/* harmony export */   "FULL_MOBILE_CRM": function() { return /* binding */ FULL_MOBILE_CRM; },
/* harmony export */   "GANTT_CHARTS": function() { return /* binding */ GANTT_CHARTS; },
/* harmony export */   "GIT_INTEGRATIONS": function() { return /* binding */ GIT_INTEGRATIONS; },
/* harmony export */   "GUESTS": function() { return /* binding */ GUESTS; },
/* harmony export */   "HIGH_LEVEL_MARKETING_PLANNING": function() { return /* binding */ HIGH_LEVEL_MARKETING_PLANNING; },
/* harmony export */   "IMPORT_EXPORT_EXCEL": function() { return /* binding */ IMPORT_EXPORT_EXCEL; },
/* harmony export */   "KANBAN_MANAGEMENT": function() { return /* binding */ KANBAN_MANAGEMENT; },
/* harmony export */   "KANBAN_VIEW": function() { return /* binding */ KANBAN_VIEW; },
/* harmony export */   "LEAD_MANAGEMENT": function() { return /* binding */ LEAD_MANAGEMENT; },
/* harmony export */   "LIMITED_COLUMN_TYPES": function() { return /* binding */ LIMITED_COLUMN_TYPES; },
/* harmony export */   "MAILCHIMP_INTEGRATION": function() { return /* binding */ MAILCHIMP_INTEGRATION; },
/* harmony export */   "MARKETING_ACTIVITY_MANAGEMENT": function() { return /* binding */ MARKETING_ACTIVITY_MANAGEMENT; },
/* harmony export */   "MARKETING_ANALYTICS": function() { return /* binding */ MARKETING_ANALYTICS; },
/* harmony export */   "MARKETING_REQUESTS_WITH_FORMS": function() { return /* binding */ MARKETING_REQUESTS_WITH_FORMS; },
/* harmony export */   "MARKETING_TEMPLATES": function() { return /* binding */ MARKETING_TEMPLATES; },
/* harmony export */   "MILESTONES_MANAGEMENT": function() { return /* binding */ MILESTONES_MANAGEMENT; },
/* harmony export */   "MOBILE": function() { return /* binding */ MOBILE; },
/* harmony export */   "MULTI_LEVEL_PERMISSIONS": function() { return /* binding */ MULTI_LEVEL_PERMISSIONS; },
/* harmony export */   "OVER_200_TEMPLATES": function() { return /* binding */ OVER_200_TEMPLATES; },
/* harmony export */   "POWERFUL_ANALYTICS_AND_DASHBOARDS": function() { return /* binding */ POWERFUL_ANALYTICS_AND_DASHBOARDS; },
/* harmony export */   "PREMIUM_SUPPORT": function() { return /* binding */ PREMIUM_SUPPORT; },
/* harmony export */   "PRIORITISED_CUSTOMER_SUPPORT": function() { return /* binding */ PRIORITISED_CUSTOMER_SUPPORT; },
/* harmony export */   "PRIVATE_BOARDS": function() { return /* binding */ PRIVATE_BOARDS; },
/* harmony export */   "PRO_AUTOMATIONS": function() { return /* binding */ PRO_AUTOMATIONS; },
/* harmony export */   "PRO_DASHBOARDS": function() { return /* binding */ PRO_DASHBOARDS; },
/* harmony export */   "PRO_INTEGRATIONS": function() { return /* binding */ PRO_INTEGRATIONS; },
/* harmony export */   "RESOURCE_ALLOCATION": function() { return /* binding */ RESOURCE_ALLOCATION; },
/* harmony export */   "SALES_ANALYTICS": function() { return /* binding */ SALES_ANALYTICS; },
/* harmony export */   "SALES_GOALS": function() { return /* binding */ SALES_GOALS; },
/* harmony export */   "SEARCH": function() { return /* binding */ SEARCH; },
/* harmony export */   "SHARABLE_DEV_BOARDS": function() { return /* binding */ SHARABLE_DEV_BOARDS; },
/* harmony export */   "SHARE_INSIGHTS_WITH_GUESTS": function() { return /* binding */ SHARE_INSIGHTS_WITH_GUESTS; },
/* harmony export */   "SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT": function() { return /* binding */ SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT; },
/* harmony export */   "SINGLE_DASHBOARD": function() { return /* binding */ SINGLE_DASHBOARD; },
/* harmony export */   "SLACK_MSTEAMS_TODOIST_INTEGRATIONS": function() { return /* binding */ SLACK_MSTEAMS_TODOIST_INTEGRATIONS; },
/* harmony export */   "SOCIAL_CALENDAR": function() { return /* binding */ SOCIAL_CALENDAR; },
/* harmony export */   "SPRINT_MANAGEMENT": function() { return /* binding */ SPRINT_MANAGEMENT; },
/* harmony export */   "STANDARD_AUTOMATIONS": function() { return /* binding */ STANDARD_AUTOMATIONS; },
/* harmony export */   "STANDARD_DASHBOARDS": function() { return /* binding */ STANDARD_DASHBOARDS; },
/* harmony export */   "STANDARD_INTEGRATIONS": function() { return /* binding */ STANDARD_INTEGRATIONS; },
/* harmony export */   "TASK_AND_PROJECT_DEPENDENCIES": function() { return /* binding */ TASK_AND_PROJECT_DEPENDENCIES; },
/* harmony export */   "TIMELINE": function() { return /* binding */ TIMELINE; },
/* harmony export */   "TIMELINE_AND_CALENDAR": function() { return /* binding */ TIMELINE_AND_CALENDAR; },
/* harmony export */   "TIMELINE_AND_GANTT_VIEWS": function() { return /* binding */ TIMELINE_AND_GANTT_VIEWS; },
/* harmony export */   "TIME_TRACKING": function() { return /* binding */ TIME_TRACKING; },
/* harmony export */   "UNLIMITED_BOARDS": function() { return /* binding */ UNLIMITED_BOARDS; },
/* harmony export */   "UNLIMITED_CONTACTS": function() { return /* binding */ UNLIMITED_CONTACTS; },
/* harmony export */   "UNLIMITED_CUSTOM_FIELDS": function() { return /* binding */ UNLIMITED_CUSTOM_FIELDS; },
/* harmony export */   "UNLIMITED_DOCS": function() { return /* binding */ UNLIMITED_DOCS; },
/* harmony export */   "UNLIMITED_GUESTS": function() { return /* binding */ UNLIMITED_GUESTS; },
/* harmony export */   "UNLIMITED_ITEMS": function() { return /* binding */ UNLIMITED_ITEMS; },
/* harmony export */   "UNLIMITED_PIPELINES": function() { return /* binding */ UNLIMITED_PIPELINES; },
/* harmony export */   "UNLIMITED_PRIVATE_BOARDS": function() { return /* binding */ UNLIMITED_PRIVATE_BOARDS; },
/* harmony export */   "UNLIMITED_PROJECTS_ITEMS_SUBITEMS": function() { return /* binding */ UNLIMITED_PROJECTS_ITEMS_SUBITEMS; },
/* harmony export */   "UNLIMITED_SHAREABLE_FORMS": function() { return /* binding */ UNLIMITED_SHAREABLE_FORMS; },
/* harmony export */   "UNLIMITED_TEMPLATES": function() { return /* binding */ UNLIMITED_TEMPLATES; },
/* harmony export */   "UNLIMITED_VIEWERS": function() { return /* binding */ UNLIMITED_VIEWERS; },
/* harmony export */   "UP_TO_THREE_BOARDS": function() { return /* binding */ UP_TO_THREE_BOARDS; },
/* harmony export */   "UP_TO_X_TEAM_MEMBERS": function() { return /* binding */ UP_TO_X_TEAM_MEMBERS; },
/* harmony export */   "WHITEBOARD": function() { return /* binding */ WHITEBOARD; },
/* harmony export */   "WORKFLOW_AND_APPROVAL_AUTOMATION": function() { return /* binding */ WORKFLOW_AND_APPROVAL_AUTOMATION; },
/* harmony export */   "WORK_PERFORMANCE_INSIGHTS": function() { return /* binding */ WORK_PERFORMANCE_INSIGHTS; }
/* harmony export */ });
/* harmony import */ var constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42349);

var UNLIMITED_BOARDS = {
    name: "pricingPage.features.titles.unlimitedBoards",
    text: "pricingPage.features.descriptions.boards"
};
var UP_TO_THREE_BOARDS = {
    name: "pricingPage.features.titles.upTo3Boards",
    text: "pricingPage.features.descriptions.boards"
};
var UNLIMITED_DOCS = {
    name: "pricingPage.features.titles.unlimitedDocs",
    text: "pricingPage.features.descriptions.docs"
};
var UNLIMITED_ITEMS = {
    name: "pricingPage.features.titles.unlimitedItems",
    text: "pricingPage.features.descriptions.unlimitedItems"
};
var FIVE_GB_STORAGE = {
    name: "pricingPage.features.titles.fiveGBStorage",
    text: "pricingPage.features.descriptions.storage"
};
var UP_TO_X_TEAM_MEMBERS = function(teamMembersCount) {
    return {
        name: {
            key: "pricingPage.features.titles.upToXMembers",
            param: teamMembersCount
        },
        text: {
            key: "pricingPage.features.descriptions.upToXMembers",
            param: teamMembersCount
        }
    };
};
var PRIORITISED_CUSTOMER_SUPPORT = {
    name: "pricingPage.features.titles.prioritisedCustomerSupport",
    text: "pricingPage.features.descriptions.prioritisedCustomerSupport"
};
var OVER_200_TEMPLATES = {
    name: "pricingPage.features.titles.templates",
    text: "pricingPage.features.descriptions.templates"
};
var COLUMN_TYPES = {
    name: "pricingPage.features.titles.columnTypes",
    text: "pricingPage.features.descriptions.columnTypes"
};
var LIMITED_COLUMN_TYPES = {
    name: "pricingPage.features.titles.limitedColumnTypes",
    text: "pricingPage.features.descriptions.columnTypes"
};
var COMMUNICATION_WITH_CONTEXT = {
    name: "pricingPage.features.titles.communication_with_context",
    text: "pricingPage.features.descriptions.communication_with_context",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Communication_-_updates.mp4")
};
var FORMS = {
    name: "pricingPage.features.titles.forms.simple",
    text: "pricingPage.features.descriptions.forms",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Form.mp4")
};
var KANBAN_VIEW = {
    name: "pricingPage.features.titles.kanbanView",
    text: "pricingPage.features.descriptions.kanbanView"
};
var WHITEBOARD = {
    name: "pricingPage.features.titles.whiteboard",
    text: "pricingPage.features.descriptions.whiteboard"
};
var MOBILE = {
    name: "pricingPage.features.titles.mobile",
    text: "pricingPage.features.descriptions.mobile"
};
var UNLIMITED_VIEWERS = {
    name: "pricingPage.features.titles.unlimitedViewers",
    text: "pricingPage.features.descriptions.viewers"
};
var LEAD_MANAGEMENT = {
    name: "pricingPage.features.titles.leadManagement",
    text: "pricingPage.features.descriptions.leadManagement"
};
var UNLIMITED_PIPELINES = {
    name: "pricingPage.features.titles.unlimitedPipelines",
    text: "pricingPage.features.descriptions.unlimitedPipelines"
};
var UNLIMITED_CONTACTS = {
    name: "pricingPage.features.titles.unlimitedContacts",
    text: "pricingPage.features.descriptions.unlimitedContacts"
};
var UNLIMITED_CUSTOM_FIELDS = {
    name: "pricingPage.features.titles.unlimitedCustomFields",
    text: "pricingPage.features.descriptions.unlimitedCustomFields"
};
var FULL_MOBILE_CRM = {
    name: "pricingPage.features.titles.fullMobileCRM",
    text: "pricingPage.features.descriptions.fullMobileCRM"
};
var DOCUMENT_MANAGEMENT = {
    name: "pricingPage.features.titles.documentManagement",
    text: "pricingPage.features.descriptions.documentManagement"
};
var API_ACCESS = {
    name: "pricingPage.features.titles.apiAccess",
    text: "pricingPage.features.descriptions.apiAccess"
};
var SINGLE_DASHBOARD = {
    name: "pricingPage.features.titles.basicDashboards",
    text: "pricingPage.features.descriptions.dashboards"
};
var TIMELINE_AND_GANTT_VIEWS = {
    name: "pricingPage.features.titles.timelineAndGanttView",
    text: "pricingPage.features.descriptions.timelineAndGanttView"
};
var TIMELINE = {
    name: "pricingPage.features.titles.timeline",
    text: "pricingPage.features.descriptions.timeline"
};
var CALENDAR = {
    name: "pricingPage.features.titles.calendar",
    text: "pricingPage.features.descriptions.calendar"
};
var TIMELINE_AND_CALENDAR = {
    name: "pricingPage.features.titles.timelineAndCalendarView",
    text: "pricingPage.features.descriptions.timelineAndCalendarView",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, "/remote_mondaycom_static/developers/features/Timeline_view.mp4")
};
var FILTERS = {
    name: "pricingPage.features.titles.filters",
    text: "pricingPage.features.descriptions.filters"
};
var SEARCH = {
    name: "pricingPage.features.titles.search",
    text: "pricingPage.features.descriptions.search"
};
var GUESTS = {
    name: "pricingPage.features.titles.guests",
    text: "pricingPage.features.descriptions.guests"
};
var EMAIL_INTEGRATION = {
    name: "pricingPage.features.titles.emailIntegration",
    text: "pricingPage.features.descriptions.emailIntegration"
};
var SALES_ANALYTICS = {
    name: "pricingPage.features.titles.salesAnalytics",
    text: "pricingPage.features.descriptions.salesAnalytics"
};
var MAILCHIMP_INTEGRATION = {
    name: "pricingPage.features.titles.mailchimpIntegration",
    text: "pricingPage.features.descriptions.mailchimpIntegration"
};
var SALES_GOALS = {
    name: "pricingPage.features.titles.salesGoals",
    text: "pricingPage.features.descriptions.salesGoals"
};
var STANDARD_DASHBOARDS = {
    name: "pricingPage.features.titles.standardDashboards",
    text: "pricingPage.features.descriptions.dashboards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Dashboard_standard.mp4")
};
var STANDARD_AUTOMATIONS = {
    name: "pricingPage.valueFeatures.titles.automations.standard",
    text: "pricingPage.features.descriptions.automations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Automations.mp4")
};
var STANDARD_INTEGRATIONS = {
    name: "pricingPage.valueFeatures.titles.integrations.standard",
    text: "pricingPage.features.descriptions.integrations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Integrations.mp4")
};
var PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.privateBoards",
    text: "pricingPage.features.descriptions.privateBoards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Private_board.mp4")
};
var BOARD_PERMISSIONS = {
    name: "pricingPage.features.titles.boardPermissions",
    text: "pricingPage.features.descriptions.boardPermissions",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Board_permission.mp4")
};
var CHART_VIEW = {
    name: "pricingPage.features.titles.chartView",
    text: "pricingPage.features.descriptions.chartView",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Chart_view.mp4")
};
var TIME_TRACKING = {
    name: "pricingPage.features.titles.timeTracking",
    text: "pricingPage.features.descriptions.timeTracking"
};
var FORMULA = {
    name: "pricingPage.features.titles.formula",
    text: "pricingPage.features.descriptions.formula"
};
var DEPENDENCY = {
    name: "pricingPage.features.titles.dependencyColumn",
    text: "pricingPage.features.descriptions.dependencyColumn"
};
var UNLIMITED_GUESTS = {
    name: "pricingPage.features.titles.unlimitedGuests",
    text: ""
};
var CUSTOMIZED_NOTIFICATIONS = {
    name: "pricingPage.features.titles.customizedNotifications",
    text: "pricingPage.features.descriptions.customizedNotifications"
};
var MARKETING_ACTIVITY_MANAGEMENT = {
    name: "pricingPage.features.titles.marketingActivityManagement",
    text: "pricingPage.features.descriptions.marketingActivityManagement"
};
var ADVANCED_PERMISSIONS = {
    name: "pricingPage.features.titles.advancedPermissions",
    text: "pricingPage.features.descriptions.boardPermissions"
};
var WORKFLOW_AND_APPROVAL_AUTOMATION = {
    name: "pricingPage.features.titles.workflowAndApprovalAutomation",
    text: "pricingPage.features.descriptions.workflowAndApprovalAutomation"
};
var ADVANCED_REPORTS = {
    name: "pricingPage.features.titles.advancedReports",
    text: "pricingPage.features.descriptions.dashboards"
};
var PRO_DASHBOARDS = {
    name: "pricingPage.features.titles.proDashboards",
    text: "pricingPage.features.descriptions.dashboards",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Dashboard.mp4")
};
var PRO_AUTOMATIONS = {
    name: "pricingPage.valueFeatures.titles.automations.pro",
    text: "pricingPage.features.descriptions.automations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Automations.mp4")
};
var PRO_INTEGRATIONS = {
    name: "pricingPage.valueFeatures.titles.integrations.pro",
    text: "pricingPage.features.descriptions.integrations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680",
    videoPath: "https://dapulse-res.cloudinary.com/video/upload/w_".concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_WIDTH */ .Ww, ",h_").concat(constants_pricing_sizes__WEBPACK_IMPORTED_MODULE_0__/* .TIER_CARD_VIDEO_HEIGHT */ .m6, ",c_fit/remote_mondaycom_static/developers/features/Integrations.mp4")
};
var ENTERPRISE_SCALE_AUTOMATIONS = {
    name: "pricingPage.features.titles.enterpriseScaleAutomations",
    text: "pricingPage.features.descriptions.enterpriseScaleAutomations",
    link: "https://support.monday.com/hc/en-us/articles/360002826680"
};
var ENTERPRISE_SPECIFIC_INTEGRATIONS = {
    name: "pricingPage.features.titles.enterpriseSpecificIntegrations",
    text: "pricingPage.features.descriptions.enterpriseSpecifciIntegrations"
};
var ENTERPRISE_GRADE_SECURITY = {
    name: "pricingPage.features.titles.enterpriseGradeSecurity",
    text: "pricingPage.features.descriptions.enterpriseGradeSecurity"
};
var ADVANCED_REPORTING = {
    name: "pricingPage.features.titles.advancedReporting",
    text: "pricingPage.features.descriptions.advancedReporting"
};
var MULTI_LEVEL_PERMISSIONS = {
    name: "pricingPage.features.titles.multiLevelPermissions",
    text: "pricingPage.features.descriptions.multiLevelPermissions"
};
var PREMIUM_SUPPORT = {
    name: "pricingPage.features.titles.premiumSupport",
    text: "pricingPage.features.descriptions.premiumSupport"
};
var ENTERPRISE_DASHBOARDS = {
    name: "pricingPage.features.titles.enterpriseDashboards",
    text: "pricingPage.features.descriptions.fiftyDashboards"
};
// added for marketing:
var MARKETING_TEMPLATES = {
    name: "pricingPage.features.titles.ready_made_marketing_templates",
    text: "pricingPage.features.descriptions.ready_made_marketing_templates"
};
var MARKETING_REQUESTS_WITH_FORMS = {
    name: "pricingPage.features.titles.marketing_requests_with_forms",
    text: "pricingPage.features.descriptions.marketing_requests_with_forms"
};
var UNLIMITED_TEMPLATES = {
    name: "pricingPage.features.titles.unlimited_templates",
    text: "pricingPage.features.descriptions.ready_made_marketing_templates"
};
var WORK_PERFORMANCE_INSIGHTS = {
    name: "pricingPage.features.titles.workPerformanceInsights",
    text: "pricingPage.features.descriptions.workPerformanceInsights"
};
var ASSETS_AND_FILE_MANAGEMENT = {
    name: "pricingPage.features.titles.assets_and_file_management",
    text: "pricingPage.features.descriptions.embed_documents_and_briefs"
};
var IMPORT_EXPORT_EXCEL = {
    name: "pricingPage.features.titles.import_export_excel",
    text: "pricingPage.features.descriptions.import_export_excel"
};
var SOCIAL_CALENDAR = {
    name: "pricingPage.features.titles.social_calendar",
    text: "pricingPage.features.descriptions.marketing_calendar"
};
var SHARE_INSIGHTS_WITH_GUESTS = {
    name: "pricingPage.features.titles.share_insights_with_guests",
    text: "pricingPage.features.descriptions.guests"
};
var MARKETING_ANALYTICS = {
    name: "pricingPage.features.titles.marketing_analytics",
    text: "pricingPage.features.descriptions.marketing_dashboards"
};
var DEADLINE_MANAGEMENT = {
    name: "pricingPage.features.titles.deadline_management",
    text: "pricingPage.features.descriptions.deadline_management"
};
var CAMPAIGN_MANAGEMENT = {
    name: "pricingPage.features.titles.campaign_management",
    text: "pricingPage.features.descriptions.campaign_management"
};
var HIGH_LEVEL_MARKETING_PLANNING = {
    name: "pricingPage.features.titles.high_level_marketing_planning",
    text: "pricingPage.features.descriptions.high_level_marketing_planning"
};
var ADOBE_CREATIVE_CLOUD_PLUGIN = {
    name: "pricingPage.features.titles.adobe_creative_cloud_plugin",
    text: "pricingPage.features.descriptions.adobe_creative_cloud_plugin"
};
var UNLIMITED_PROJECTS_ITEMS_SUBITEMS = {
    name: "pricingPage.features.titles.unlimitedProjectsItemsSubitems",
    text: "pricingPage.features.descriptions.unlimitedProjectsItemsSubitems"
};
var UNLIMITED_SHAREABLE_FORMS = {
    name: "pricingPage.features.titles.unlimitedShareableForms",
    text: "pricingPage.features.descriptions.unlimitedShareableForms"
};
var FILE_MANAGEMENT = {
    name: "pricingPage.features.titles.fileManagement",
    text: "pricingPage.features.descriptions.fileManagement"
};
var GANTT_CHARTS = {
    name: "pricingPage.features.titles.ganttCharts",
    text: "pricingPage.features.descriptions.ganttCharts"
};
var CUSTOM_NOTIFICATIONS_AND_REMINDERS = {
    name: "pricingPage.features.titles.customNotificationsAndReminders",
    text: "pricingPage.features.descriptions.customNotificationsAndReminders"
};
var SIMPLE_PROJECT_PORTFOLIO_MANAGEMENT = {
    name: "pricingPage.features.titles.projectPortfolioManagement",
    text: "pricingPage.features.descriptions.projectPortfolioManagement"
};
var CALENDAR_SYNC = {
    name: "pricingPage.features.titles.calendarSync",
    text: "pricingPage.features.descriptions.calendarSync"
};
var BASIC_ANALYTICS_AND_DASHBOARDS = {
    name: "pricingPage.features.titles.basicAnalytics",
    text: "pricingPage.features.descriptions.basicAnalytics"
};
var TASK_AND_PROJECT_DEPENDENCIES = {
    name: "pricingPage.features.titles.taskAndProjectDependencies",
    text: "pricingPage.features.descriptions.taskAndProjectDependencies"
};
var MILESTONES_MANAGEMENT = {
    name: "pricingPage.features.titles.milestonesManagement",
    text: "pricingPage.features.descriptions.milestonesManagement"
};
var RESOURCE_ALLOCATION = {
    name: "pricingPage.features.titles.resourceAllocation",
    text: "pricingPage.features.descriptions.resourceAllocation"
};
var POWERFUL_ANALYTICS_AND_DASHBOARDS = {
    name: "pricingPage.features.titles.powerfulAnalytics",
    text: "pricingPage.features.descriptions.powerfulAnalytics"
};
var UNLIMITED_PRIVATE_BOARDS = {
    name: "pricingPage.features.titles.unlimitedPrivateBoards",
    text: "pricingPage.features.descriptions.privateBoards"
};
var ADVANCED_FORMULA_CAPABILITIES = {
    name: "pricingPage.features.titles.advancedFormulaCapabilities",
    text: "pricingPage.features.descriptions.formula"
};
var SLACK_MSTEAMS_TODOIST_INTEGRATIONS = {
    name: "pricingPage.features.titles.slackMSTeamsTodoistIntegrations",
    text: "pricingPage.features.descriptions.slackMSTeamsTodoistIntegrations"
};
var ADVANCED_PROJECT_PORTFOLIO_MANAGEMENT = {
    name: "pricingPage.features.titles.advancedProjectPortfolioManagement",
    text: "pricingPage.features.descriptions.advancedProjectPortfolioManagement"
};
var ENTERPRISE_INTEGRATIONS = {
    name: "pricingPage.features.titles.enterpriseIntegrations",
    text: "pricingPage.features.descriptions.enterpriseIntegrations"
};
var SPRINT_MANAGEMENT = {
    name: "pricingPage.features.titles.sprint_management",
    text: "pricingPage.features.descriptions.sprint_management"
};
var KANBAN_MANAGEMENT = {
    name: "pricingPage.features.titles.kanban_management",
    text: "pricingPage.features.descriptions.kanban_management"
};
var DEV_TEMPLATES = {
    name: "pricingPage.features.titles.dev_templates",
    text: "pricingPage.features.descriptions.dev_templates"
};
var BUILT_IN_WORKOCS = {
    name: "pricingPage.features.titles.workdocs",
    text: "pricingPage.features.descriptions.workdocs"
};
var SHARABLE_DEV_BOARDS = {
    name: "pricingPage.products.software.featuresList.shareableBoardsWithExternalStakeholders",
    text: "pricingPage.products.software.featuresList.shareableBoardsWithExternalStakeholders.description"
};
var GIT_INTEGRATIONS = {
    name: "pricingPage.features.titles.git_integrations",
    text: "pricingPage.features.descriptions.git_integrations"
};
var AGILE_REPORTING = {
    name: "pricingPage.features.titles.agile_reporting",
    text: "pricingPage.features.descriptions.agile_reporting"
};
var DEV_FEEDBACK_FORMS = {
    name: "pricingPage.products.software.featuresList.customerFeedbackAndRequests",
    text: "pricingPage.products.software.featuresList.customerFeedbackAndRequests.description"
};


/***/ }),

/***/ 93833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Y": function() { return /* binding */ buttonStyles; },
/* harmony export */   "Is": function() { return /* binding */ buttonColors; },
/* harmony export */   "u_": function() { return /* binding */ ELEVATE_BUTTON_COLLOR_NAME; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);
/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(273);



var ELEVATE_BUTTON_COLLOR_NAME = styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.ELEVATE_BUTTON_GRADIANT_COLOR_NAME;
var buttonColors = [
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME,
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME,
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR,
    styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORKFORMS_RED_COLOR_NAME
]; // after removing old colors - change to:  Object.keys(buttonStyles);
var _obj;
var buttonStyles = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.IRIS_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORK_OS_IRIS_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BLUE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BLUE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DODGER_BLUE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DODGER_BLUE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.SPACE_BLUE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.SPACE_BLUE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORKFORMS_RED_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WORKFORMS_RED_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_CRM_GREEN_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_CRM_GREEN_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_MARKETING_RED_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_MARKETING_RED_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_PROJECTS_ORANGE_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_PROJECTS_ORANGE_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_DEV_GREEN_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.DARK_DEV_GREEN_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, ELEVATE_BUTTON_COLLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_BLACK_TEXT_COLOR],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.ELEVATE_BUTTON_GRADIANT_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_GREEN_DARK_TINT_01_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_DARK_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.CRM_DARK_TINT_01_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_DARK_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_DARK_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_DARK_COLOR_NAME
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_PRIMARY_COLOR_NAME, {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.BRAND_SERVICE_PRIMARY_COLOR_NAME
}), // old colors - kept for supporting old page configs:
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "pink", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "pink"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "purple", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "purple"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "royal", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "royal"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "green", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[styles_color_consts__WEBPACK_IMPORTED_MODULE_1__.WHITE_COLOR_NAME],
    backgroundColorName: "green"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "yellow", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
    backgroundColorName: "yellow"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "orange", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
    backgroundColorName: "orange"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "light-blue", {
    textColor: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].mud */ .Z.mud,
    backgroundColorName: "light-blue-video-background"
}), _obj);


/***/ }),

/***/ 73759:
/***/ (function(module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "COMPONENTS_SHADOW_PROPS", ({
    enumerable: true,
    get: function() {
        return COMPONENTS_SHADOW_PROPS;
    }
}));
var BODY_CONTENT_HORIZONTAL_PADDING = 96;
var CARD_BORDER_STYLE = {
    FULL: "full",
    TOP: "top",
    BOTTOM: "bottom",
    NONE: "none"
};
var COMPONENTS_SHADOW_PROPS = {
    offsetX: 0,
    offsetY: 8,
    blurRadius: 48,
    defaultOpacity: 0.16,
    hoverOpacity: 0.32
};
var getComponentBoxShadow = function(opacity) {
    return "box-shadow: 0px ".concat(COMPONENTS_SHADOW_PROPS.offsetY, "px ").concat(COMPONENTS_SHADOW_PROPS.blurRadius / 2, "px 0 rgba(29, 140, 242, ").concat(opacity, ");");
};
var getComponentShadowFilter = function() {
    var opacity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : COMPONENTS_SHADOW_PROPS.defaultOpacity;
    return "filter: drop-shadow(0px ".concat(COMPONENTS_SHADOW_PROPS.offsetY, "px ").concat(COMPONENTS_SHADOW_PROPS.blurRadius / 2, "px rgba(29, 140, 242, ").concat(opacity, "));");
};
var getMobileComponentShadowFilter = function(opacity) {
    return "filter: drop-shadow(0px ".concat(COMPONENTS_SHADOW_PROPS.offsetY, "px ").concat(COMPONENTS_SHADOW_PROPS.blurRadius / 3, "px rgba(29, 140, 242, ").concat(opacity, "));");
};
var getComponentShadow = function() {
    return getComponentBoxShadow(COMPONENTS_SHADOW_PROPS.defaultOpacity);
};
var getComponentShadowWithHoverEffect = function() {
    return getComponentBoxShadow(COMPONENTS_SHADOW_PROPS.hoverOpacity);
};
var COMPONENTS_SHADOW_FILTER = getComponentShadowFilter(0.5);
var MOBILE_COMPONENTS_SHADOW_FILTER = getMobileComponentShadowFilter(0.3);
module.exports = {
    BODY_CONTENT_HORIZONTAL_PADDING: BODY_CONTENT_HORIZONTAL_PADDING,
    COMPONENTS_SHADOW_PROPS: COMPONENTS_SHADOW_PROPS,
    CARD_BORDER_STYLE: CARD_BORDER_STYLE,
    COMPONENTS_SHADOW_FILTER: COMPONENTS_SHADOW_FILTER,
    MOBILE_COMPONENTS_SHADOW_FILTER: MOBILE_COMPONENTS_SHADOW_FILTER,
    getComponentShadow: getComponentShadow,
    getComponentShadowWithHoverEffect: getComponentShadowWithHoverEffect,
    getComponentShadowFilter: getComponentShadowFilter,
    getMobileComponentShadowFilter: getMobileComponentShadowFilter
};


/***/ }),

/***/ 72898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ positionTypes; },
/* harmony export */   "y": function() { return /* binding */ getImagePositionStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var positionTypes = {
    TOP_LEFT: "TOP_LEFT",
    TOP_CENTER: "TOP_CENTER",
    TOP_RIGHT: "TOP_RIGHT",
    CENTER_LEFT: "CENTER_LEFT",
    CENTER_CENTER: "CENTER_CENTER",
    CENTER_RIGHT: "CENTER_RIGHT",
    BOTTOM_LEFT: "BOTTOM_LEFT",
    BOTTOM_CENTER: "BOTTOM_CENTER",
    BOTTOM_RIGHT: "BOTTOM_RIGHT"
};
var _obj;
var imagePositionStylesMapping = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.TOP_LEFT, {
    justifyContent: "flex-start",
    alignItems: "flex-start"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.TOP_CENTER, {
    justifyContent: "center",
    alignItems: "flex-start"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.TOP_RIGHT, {
    justifyContent: "flex-end",
    alignItems: "flex-start"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.CENTER_LEFT, {
    justifyContent: "flex-start",
    alignItems: "center"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.CENTER_CENTER, {
    justifyContent: "center",
    alignItems: "center"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.CENTER_RIGHT, {
    justifyContent: "flex-end",
    alignItems: "center"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.BOTTOM_LEFT, {
    justifyContent: "flex-start",
    alignItems: "flex-end"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.BOTTOM_CENTER, {
    justifyContent: "center",
    alignItems: "flex-end"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, positionTypes.BOTTOM_RIGHT, {
    justifyContent: "flex-end",
    alignItems: "flex-end"
}), _obj);
var getImagePositionStyles = function(imagePosition) {
    return imagePositionStylesMapping[imagePosition];
};


/***/ }),

/***/ 71021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ MARGIN_BETWEEN_CARDS; },
/* harmony export */   "p": function() { return /* binding */ COLUMN_WIDTH; }
/* harmony export */ });
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(698);

var MARGIN_BETWEEN_CARDS = 30;
var COLUMN_WIDTH = (constants_vp_sizes__WEBPACK_IMPORTED_MODULE_0__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld - 5 * MARGIN_BETWEEN_CARDS) / 4;


/***/ }),

/***/ 36233:
/***/ (function(module) {


var getExactEventNameAbTestVariant = function(abTestExactEventName, abTestVariants) {
    if (!abTestExactEventName || !abTestVariants || abTestVariants.length == 0) return null;
    var test = abTestVariants.find(function(abTest) {
        return abTest.name === abTestExactEventName;
    });
    return test ? test.variant : null;
};
module.exports = {
    getExactEventNameAbTestVariant: getExactEventNameAbTestVariant
};


/***/ }),

/***/ 46724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ enterV13TestIfNeeded; },
  "EF": function() { return /* binding */ getFreeTierFeaturesByAbTest; },
  "FW": function() { return /* binding */ getFreeTierSeatsCountByAbTest; },
  "_n": function() { return /* binding */ getIsFreeOver20ColumnTypes; },
  "J6": function() { return /* binding */ getIsUnlimitedBoards; },
  "gd": function() { return /* binding */ shouldHideBasic; },
  "GV": function() { return /* binding */ shouldSeeProductsPricingPage; },
  "fy": function() { return /* binding */ shouldSeeV10PricingVersion; },
  "H6": function() { return /* binding */ shouldShowPricingSubTitleV2; },
  "u0": function() { return /* binding */ shouldShowPurchaseNow; },
  "Ce": function() { return /* binding */ shouldShowTalkToSalesCta; },
  "RT": function() { return /* binding */ shouldShowTypeformContactUs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
// EXTERNAL MODULE: ./constants/cookies.js
var constants_cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_feature_collections.js
var value_feature_collections = __webpack_require__(78217);
;// CONCATENATED MODULE: ./constants/monetization-ab-tests.ts
var PURCHASE_NOW_AB_TEST = {
    test_name: "purchase_now_ab_test",
    new_variation_name: "new_with_purchase_now_button"
};
var PRICING_SUB_TITLE_V2_AB_TEST = {
    test_name: "pricing_page_sub_title_v2_ab_test",
    new_variation_name: "new_pricing_with_sub_title_v2"
};
var HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST = {
    test_name: "homepage_platform_pricing_contact_us_cta_ab_test",
    new_variation_name: "new_cta_with_talk_to_sales"
};
var HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG = {
    test_name: "homepage_pricing_enterprise_contact_us_typeform_feature_flag",
    new_variation_name: "new_homepage_pricing_enterprise_contact_us_typeform_feature_flag"
};

;// CONCATENATED MODULE: ./constants/force-pricing.ts
var PRICING_SUB_TITLE_V2 = "sub_title_v2";
var FORCE_TALK_TO_SALES = "talk_to_sales";

// EXTERNAL MODULE: ./utils/mobile.js
var mobile = __webpack_require__(34955);
// EXTERNAL MODULE: ./constants/pricing/pricing-page/features/value_features.js
var value_features = __webpack_require__(49127);
;// CONCATENATED MODULE: ./services/ab-tests/monetization-ab-tests-service.js












var shouldHideBasic = function(param) {
    var abTests = param.abTests, forcePricing = param.forcePricing, cookies = param.cookies, hasStudentPlan = param.hasStudentPlan;
    if (hasStudentPlan) return true; // First we check if we're in student plan mode - in this mode we don't show the basic tier
    var ref = cookies || {}, platformCookieValue = ref[constants_cookies.PLATFORM_HIDE_BASIC_COOKIE]; // The visitor might have came from the platform before, so we check if we hide basic in the platform
    if (platformCookieValue) return platformCookieValue === "true";
    if (forcePricing === "without_basic") return true; // We want to test it by ourselves so we use force_pricing query param.
    return (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_HIDE_BASIC_AB_TEST.test_name) === new_ab_tests.HOMEPAGE_HIDE_BASIC_AB_TEST.new_variation_name;
};
var shouldSeeProductsPricingPage = function(param) {
    var forcePricing = param.forcePricing;
    return forcePricing === "products";
};
var shouldSeeV10PricingVersion = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === "v10") return true;
    var platformCookie = cookies[constants_cookies.PLATFORM_PRICING_VERSION_COOKIE];
    if (platformCookie) return platformCookie === (pricing_versions_default()).VERSION_10;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_V10_PRICING_VERSION_AB_TEST.test_name);
    return abTestVariant === new_ab_tests.HOMEPAGE_V10_PRICING_VERSION_AB_TEST.new_variation_name;
};
var enterV13TestIfNeeded = function(abTests, cookies, forcePricing, isV13PricingVersion) {
    if (cookies === null || cookies === void 0 ? void 0 : cookies[constants_cookies.PLATFORM_PRICING_VERSION_COOKIE]) return;
    if (forcePricing) return;
    // Report to Bigbrain that the user entered the test
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, new_ab_tests.HOMEPAGE_V13_PRICING_VERSION_AB_TEST.test_name, true);
    if (isV13PricingVersion || abTestVariant === new_ab_tests.HOMEPAGE_V13_PRICING_VERSION_AB_TEST.new_variation_name) {
        (0,cookies_service/* setCookieIfNeeded */.cr)(constants_cookies.HOMEPAGE_PRICING_VERSION_COOKIE, (pricing_versions_default()).VERSION_13, {
            expires: 90
        });
    } else {
        (0,cookies_service/* setCookieIfNeeded */.cr)(constants_cookies.HOMEPAGE_PRICING_VERSION_COOKIE, (pricing_versions_default()).DEFAULT_VERSION, {
            expires: 90
        });
    }
};
var getFreeTierVersion = function(cookies, forcePricing) {
    var platformCookie = cookies[constants_cookies.PLATFORM_FREE_TIER_VERSION_COOKIE];
    var forceFreeTierVersion = forcePricing || platformCookie;
    var _obj;
    var variantToVersion = (_obj = {}, (0,_define_property/* default */.Z)(_obj, new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_b, "2022_a"), (0,_define_property/* default */.Z)(_obj, new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_c, "2022_b"), _obj);
    var freeTierVersion = forceFreeTierVersion || variantToVersion[new_ab_tests.HOMEPAGE_FREE_TIER_2022_ABC_TEST.new_variation_name_b];
    return freeTierVersion;
};
var getFreeTierFeaturesByAbTest = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return [
                value_features.UP_TO_THREE_BOARDS,
                value_features.UNLIMITED_DOCS,
                value_features.OVER_200_TEMPLATES,
                value_features.LIMITED_COLUMN_TYPES,
                value_features.UP_TO_X_TEAM_MEMBERS(pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3),
                value_features.MOBILE
            ];
        case "2022_b":
            return [
                value_features.UP_TO_THREE_BOARDS,
                value_features.UNLIMITED_DOCS,
                value_features.OVER_200_TEMPLATES,
                value_features.LIMITED_COLUMN_TYPES,
                value_features.UP_TO_X_TEAM_MEMBERS(pricing/* FREE_TIER_2022_SEATS_LIMIT */.no),
                value_features.MOBILE
            ];
        default:
            return value_feature_collections/* FREE_TIER_VALUE_FEATURES */.tL;
    }
};
var getFreeTierSeatsCountByAbTest = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3;
        case "2022_b":
            return pricing/* FREE_TIER_2022_SEATS_LIMIT */.no;
        default:
            return pricing/* FREE_TIER_2021_SEATS_LIMIT */.F3;
    }
};
var getIsFreeOver20ColumnTypes = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return false;
        case "2022_b":
            return false;
        default:
            return true;
    }
};
var getIsUnlimitedBoards = function(param) {
    var _cookies = param.cookies, cookies = _cookies === void 0 ? {} : _cookies, forcePricing = param.forcePricing;
    var freeTierVersion = getFreeTierVersion(cookies, forcePricing);
    switch(freeTierVersion){
        case "2022_a":
            return false;
        case "2022_b":
            return false;
        default:
            return true;
    }
};
var shouldShowPurchaseNow = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === "purchase_now") return true;
    if ((0,mobile/* isMobile */.tq)()) return false;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, PURCHASE_NOW_AB_TEST.test_name, true);
    return abTestVariant === PURCHASE_NOW_AB_TEST.new_variation_name;
};
var shouldShowPricingSubTitleV2 = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === PRICING_SUB_TITLE_V2) return true;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, PRICING_SUB_TITLE_V2_AB_TEST.test_name, true);
    return abTestVariant === PRICING_SUB_TITLE_V2_AB_TEST.new_variation_name;
};
var shouldShowTalkToSalesCta = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests, forcePricing = param.forcePricing;
    if (forcePricing === FORCE_TALK_TO_SALES) return true;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST.test_name, true);
    return abTestVariant === HOMEPAGE_PLATFORM_PRICING_CONTACT_US_CTA_AB_TEST.new_variation_name;
};
var shouldShowTypeformContactUs = function(param) {
    var _abTests = param.abTests, abTests = _abTests === void 0 ? [] : _abTests;
    var abTestVariant = (0,new_ab_tests_service.getAbTestVariantNew)(abTests, HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG.test_name, true);
    return abTestVariant === HOMEPAGE_PRICING_ENTERPRISE_CONTACT_US_TYPEFORM_FEATURE_FLAG.new_variation_name;
};


/***/ }),

/***/ 12783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ConditionalWrapper; }
/* harmony export */ });
var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};


/***/ })

}]);